function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { HEL_AUDIO_TYPE_VOICE, worldViewerWindow } from '../../const';
import { debugLog } from '../../debugLog';
import { helcore_video_play } from '../../heliodor_core_video_callee';
import { closeLocalStream, getLocalStream, getMixerRealSettingAt, getSkywayAvatarNumberForSend, getSkywayCustomAvatarIconURL, getSkywayName, getSkywayOnTellScreenShareStart, getSkywayOnTellWaitScreenShare, getSkywayStartToggle, getSkywayUseCustomAvatarIcon, setLocalStream } from '../../logics/dataOps';
import { getAudioInputDevices } from '../../logics/device';
import { getVideo } from '../../logics/domOps';
import { AgoraClient } from '../AgoraClient';
import { CChannelSessionApi } from '../CChannelSessionApi';
import { CCrpRegist } from '../CCrpRegist';
import { EHeliMicPermissionState } from '../IHeliNetwork';
import { CApiNotification } from '../apiNotificationLib/CApiNotification';
import { CHELCarnelianSmcnPlayer } from './CHELCarnelianSmcnPlayer';
const parseJwt = (token)=>{
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
};
// マイク許可を得るための仮初のlocalStream
const setLocalStreamFromSmcnLocalTrack = async ()=>{
    try {
        const localMediaStream = await navigator.mediaDevices.getUserMedia({
            audio: true,
            video: false
        });
        localMediaStream.getAudioTracks()[0].enabled = false;
        setLocalStream(localMediaStream);
        return true;
    } catch (err) {
        // マイクデバイスがない場合でも処理を続行する
        console.warn(err);
        return false;
    }
};
const setCrpFront = (crpFront)=>{
    worldViewerWindow.crpFront = crpFront;
};
const getCrpFront = ()=>{
    return worldViewerWindow.crpFront;
};
const converChannelSessionToPlayerInfo = (channelSession)=>{
    return {
        channel_session_code: channelSession.channel_session_code,
        user_code: channelSession.user_code,
        user_role: channelSession.user_role,
        icon: null,
        avatar: null,
        name: null,
        user_type: channelSession.user_type
    };
};
export class CHeliChsPlayerInfo {
    getValue(key) {
        if (this.m_playerInfo) {
            // @ts-ignore
            return this.m_playerInfo[key];
        }
        return undefined;
    }
    getUserId() {
        var _this_m_playerInfo;
        return ((_this_m_playerInfo = this.m_playerInfo) === null || _this_m_playerInfo === void 0 ? void 0 : _this_m_playerInfo.user_code) || '';
    }
    getChannelSessionCode() {
        var _this_m_playerInfo;
        return ((_this_m_playerInfo = this.m_playerInfo) === null || _this_m_playerInfo === void 0 ? void 0 : _this_m_playerInfo.channel_session_code) || '';
    }
    getRole() {
        var _this_m_playerInfo, _this_m_playerInfo1;
        if (!((_this_m_playerInfo = this.m_playerInfo) === null || _this_m_playerInfo === void 0 ? void 0 : _this_m_playerInfo.user_role)) {
            return 'normal';
        }
        return ((_this_m_playerInfo1 = this.m_playerInfo) === null || _this_m_playerInfo1 === void 0 ? void 0 : _this_m_playerInfo1.user_role) || '';
    }
    constructor(playerInfo){
        _defineProperty(this, "m_playerInfo", void 0);
        this.m_playerInfo = playerInfo;
    }
}
export class IHeliCarnelianSmcnPosChannelList {
    getList() {
        const iHeliPosChList = [];
        let ArrayNum = 0;
        for(let i = this.m_offset; i < this.m_position_channels.length; i++){
            if (this.m_limit !== undefined && this.m_limit !== null && ArrayNum >= this.m_limit) {
                break;
            }
            iHeliPosChList.push(this.m_position_channels[i]);
            ArrayNum++;
        }
        // @ts-ignore
        return iHeliPosChList;
    }
    setError({ code , data  }) {
        this.m_errorCode = code;
        this.m_errorData = data;
    }
    getErrorCode() {
        return this.m_errorCode;
    }
    getErrorData() {
        return this.m_errorData;
    }
    isValid() {
        return this.m_errorCode === null && this.m_errorData === null;
    }
    constructor(postion_channels = [], offset = 0, limit = null){
        _defineProperty(this, "m_position_channels", void 0);
        _defineProperty(this, "m_offset", void 0);
        _defineProperty(this, "m_limit", void 0);
        _defineProperty(this, "m_errorCode", null);
        _defineProperty(this, "m_errorData", null);
        this.m_position_channels = postion_channels;
        this.m_offset = offset;
        this.m_limit = limit;
    }
}
export class IHeliCarnelianSmcnVoiceChannelList {
    // @ts-ignore
    getList() {
        const iHeliVoiceChList = [];
        let ArrayNum = 0;
        for(let i = this.m_offset; i < this.m_vocie_channels.length; i++){
            if (this.m_limit !== undefined && this.m_limit !== null && ArrayNum >= this.m_limit) {
                break;
            }
            iHeliVoiceChList.push(this.m_vocie_channels[i]);
            ArrayNum++;
        }
        return iHeliVoiceChList;
    }
    setError({ code , data  }) {
        this.m_errorCode = code;
        this.m_errorData = data;
    }
    getErrorCode() {
        return this.m_errorCode;
    }
    getErrorData() {
        return this.m_errorData;
    }
    isValid() {
        return this.m_errorCode === null && this.m_errorData === null;
    }
    constructor(vocie_channels = [], offset = 0, limit = null){
        _defineProperty(this, "m_vocie_channels", void 0);
        _defineProperty(this, "m_offset", void 0);
        _defineProperty(this, "m_limit", void 0);
        _defineProperty(this, "m_errorCode", null);
        _defineProperty(this, "m_errorData", null);
        this.m_vocie_channels = vocie_channels;
        this.m_offset = offset;
        this.m_limit = limit;
    }
}
export class IHeliCarnelianSmcnLiveChannelList {
    // @ts-ignore
    getList() {
        const iHeliLiveChList = [];
        let ArrayNum = 0;
        for(let i = this.m_offset; i < this.m_live_channels.length; i++){
            if (this.m_limit !== undefined && this.m_limit !== null && ArrayNum >= this.m_limit) {
                break;
            }
            iHeliLiveChList.push(this.m_live_channels[i]);
            ArrayNum++;
        }
        return iHeliLiveChList;
    }
    setError({ code , data  }) {
        this.m_errorCode = code;
        this.m_errorData = data;
    }
    getErrorCode() {
        return this.m_errorCode;
    }
    getErrorData() {
        return this.m_errorData;
    }
    isValid() {
        return this.m_errorCode === null && this.m_errorData === null;
    }
    constructor(live_channels = [], offset = 0, limit = null){
        _defineProperty(this, "m_live_channels", void 0);
        _defineProperty(this, "m_offset", void 0);
        _defineProperty(this, "m_limit", void 0);
        _defineProperty(this, "m_errorCode", null);
        _defineProperty(this, "m_errorData", null);
        this.m_live_channels = live_channels;
        this.m_offset = offset;
        this.m_limit = limit;
    }
}
export class CHeliCarnelianSmcnPosChannel {
    isConnected() {
        const crpFront = getCrpFront();
        if (crpFront && crpFront.ownUser && crpFront.ownUser.positionChannelCode && crpFront.ownUser.positionChannelCode === this.m_channelId && crpFront.ownObjectId) {
            return true;
        }
        return false;
    }
    getChannelId() {
        return this.m_channelId || '';
    }
    getErrorCode() {
        return this.m_errorCode;
    }
    getErrorData() {
        return this.m_errorData;
    }
    setError({ code , data  }) {
        this.m_errorCode = code;
        this.m_errorData = data;
    }
    isValid() {
        return this.m_errorCode === null && this.m_errorData === null;
    }
    getValue(key) {
        if (this.positionChannel) {
            // @ts-ignore
            return this.positionChannel[key];
        }
        return undefined;
    }
    // 座標1対N音声か否か
    isMultiVc() {
        return this.m_allowMultiVoiceChannel;
    }
    async join(authorityJwt, ticketJwt) {
        console.log('CarnelianSmcn joinPosChannel start channelid:', this.m_channelId);
        const authorizationJwt = authorityJwt;
        // API対応したらHeliportも対応して入室リクエストに使用する
        try {
            var _resEntryPch_data_position_channel_id, _this_m_parent_m_IHeliNetworkCallback;
            const resEntryPch = await worldViewerWindow.heliport.v3.api.channelSessionApi.enterPositionChannel(this.m_channelId, authorizationJwt, ticketJwt);
            if (resEntryPch.status !== 'ok') {
                var _resEntryPch_errorCode;
                // 入室エラー
                this.setError({
                    code: (_resEntryPch_errorCode = resEntryPch.errorCode) !== null && _resEntryPch_errorCode !== void 0 ? _resEntryPch_errorCode : resEntryPch.code,
                    data: resEntryPch.data
                });
                return false;
            }
            console.log('CarnelianSmcn joinPosChannel ChS-API enterPos resEntryPch:', resEntryPch);
            const channelSessionJwt = (await worldViewerWindow.heliport.v3.api.channelSessionApi.getChannelSessionJwt()).data;
            this.m_parent.m_selfPlayerInfo = parseJwt(channelSessionJwt);
            if (resEntryPch.data.position_channel !== undefined) {
                this.positionChannel = resEntryPch.data.position_channel;
            }
            this.m_parent.setCurrentPositionChannel(this);
            console.log('CRP open start');
            worldViewerWindow.crpFront.sendMovement([
                0,
                0,
                0
            ], [
                0,
                0,
                0,
                0
            ], [
                0,
                0,
                0
            ], 1, 0);
            await worldViewerWindow.crpFront.open(channelSessionJwt);
            // デフォルトグループへコネクト
            const decodeJwt = parseJwt(channelSessionJwt);
            if (!this.m_parent.m_Mic_ready) {
                if (!await setLocalStreamFromSmcnLocalTrack()) {
                    console.log('CRP open done By Mic Not Found');
                    return true;
                }
                await this.m_parent.initLocalMicInput(null);
            }
            const type = 'smcn';
            const mode = 'talk';
            const roomTarget = 'position_channel_code';
            const disableRtcUser = false;
            const token = (await worldViewerWindow.heliport.v3.api.genericRtcToken.getToken({
                channelSessionJwt,
                type,
                mode,
                disableRtcUser,
                roomTarget
            })).data;
            const smcnToken = token.token;
            const smcnUserId = token.user_id;
            await worldViewerWindow.smcnClient.setToken(smcnToken);
            // ユーザIDとワールドID（ポジションチャンネル別にするため、position_channel_codeとする）
            // 環境音の区切りは指定したワールドID別となる
            const CONFIG = worldViewerWindow.getIngameConfig();
            const option = {
                isSpeakerMode: decodeJwt.user_role === 'presenter'
            };
            // 0が扱えないため、パースして使用する
            const xLength = parseInt(CONFIG.SMCN_SPLIT_X_LENGTH);
            const yLength = parseInt(CONFIG.SMCN_SPLIT_Y_LENGTH);
            const zLength = parseInt(CONFIG.SMCN_SPLIT_Z_LENGTH);
            if (xLength > 0 && yLength > 0 && zLength) {
                option.defaultGroupSplit = {
                    length: {
                        x: xLength,
                        y: yLength,
                        z: zLength
                    },
                    offset: {
                        x: parseFloat(CONFIG.SMCN_SPLIT_X_OFFSET),
                        y: parseFloat(CONFIG.SMCN_SPLIT_Y_OFFSET),
                        z: parseFloat(CONFIG.SMCN_SPLIT_Z_OFFSET)
                    }
                };
            }
            await this.smcnConnect(smcnUserId, decodeJwt.position_channel_code, option);
            // デフォルトグループ用ダミーボイスチャンネルの作成
            const voiceChannelDetail = {
                channel_id: resEntryPch.data.position_channel.channel_id + '__' + this.m_parent.m_SMCNDefaultVoiceChannelName,
                position_channel_id: ((_resEntryPch_data_position_channel_id = resEntryPch.data.position_channel.id) === null || _resEntryPch_data_position_channel_id === void 0 ? void 0 : _resEntryPch_data_position_channel_id.toString()) || '0',
                channel_type: resEntryPch.data.position_channel.channel_type,
                max_player_count: resEntryPch.data.position_channel.max_player_count,
                name: this.m_parent.m_SMCNDefaultVoiceChannelName,
                create_user_code: resEntryPch.data.authorization.user_code,
                description: '',
                users: [],
                channel_sessions: [],
                is_global: true
            };
            this.m_parent.m_SMCNDefaultVoiceChannel = new CHeliCarnelianSmcnVoiceChannel(this.m_parent, voiceChannelDetail);
            this.m_parent.setCurrentVoiceChannel(this.m_parent.m_SMCNDefaultVoiceChannel);
            await this.m_parent.checkMicPermissionState();
            (_this_m_parent_m_IHeliNetworkCallback = this.m_parent.m_IHeliNetworkCallback) === null || _this_m_parent_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_parent_m_IHeliNetworkCallback.OnNetVoiceConnected(decodeJwt.channel_session_code);
            console.log('CRP open done');
            return true;
        } catch (error) {
            console.error('iHeliNet joinPosChannel error:', error);
            this.setError({
                code: '400',
                data: error
            });
            return false;
        }
    }
    async smcnConnect(userId, worldId, option) {
        try {
            await worldViewerWindow.smcnClient.connect(userId, worldId, option);
        } catch (error) {
            console.error(`[SmcnClient] Connect: ${error}`);
            // 何らかの理由によりコネクションに失敗（大体は制限人数オーバーが原因）
            if (window.confirm('SmcnClientクラウドレンダリングとの接続に失敗しました、復帰のためにはページをリロードしてください')) {
                location.reload();
            }
            return;
        }
    }
    async leave() {
        var _this_m_parent_m_CChannelSessionApi, // 音声チャンネルからの退出を通知
        _this_m_parent_m_IHeliNetworkCallback;
        this.m_parent.setCurrentPositionChannel(null);
        this.m_parent.releaseAllPlayer();
        (_this_m_parent_m_CChannelSessionApi = this.m_parent.m_CChannelSessionApi) === null || _this_m_parent_m_CChannelSessionApi === void 0 ? void 0 : _this_m_parent_m_CChannelSessionApi.stopHeartbeat();
        await worldViewerWindow.crpFront.close();
        const voCh = this.m_parent.getCurrentVoiceChannel();
        if (voCh) {
            await voCh.leave();
        }
        const liveCh = this.m_parent.getCurrentLiveChannel();
        if (liveCh) {
            await liveCh.leave();
        }
        try {
            const resLeavePosCh = await worldViewerWindow.heliport.v3.api.channelSessionApi.leavePositionChannel();
            if (resLeavePosCh.status !== 'ok') {
                var _resLeavePosCh_errorCode;
                this.setError({
                    code: (_resLeavePosCh_errorCode = resLeavePosCh.errorCode) !== null && _resLeavePosCh_errorCode !== void 0 ? _resLeavePosCh_errorCode : resLeavePosCh.code,
                    data: resLeavePosCh.data
                });
                return false;
            }
        } catch (error) {
            this.setError({
                code: '400',
                data: error
            });
            return false;
        }
        this.m_parent.m_SMCNDefaultVoiceChannel = null;
        this.m_parent.setCurrentVoiceChannel(null);
        (_this_m_parent_m_IHeliNetworkCallback = this.m_parent.m_IHeliNetworkCallback) === null || _this_m_parent_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_parent_m_IHeliNetworkCallback.OnNetVoiceDisconnected();
        return true;
    }
    async update(params) {
        try {
            const result = await worldViewerWindow.heliport.v3.api.channelSessionApi.updatePositionChannel(this.m_channelId, params.channelType, params.name, params.description);
            if (result.status !== 'ok') {
                var _result_errorCode;
                this.setError({
                    code: (_result_errorCode = result.errorCode) !== null && _result_errorCode !== void 0 ? _result_errorCode : result.code,
                    data: result.data
                });
                return false;
            }
            this.positionChannel = result.data.position_channel;
            return true;
        } catch (error) {
            this.setError({
                code: '400',
                data: error
            });
            return false;
        }
    }
    async refresh() {
        try {
            const resPosChDetail = await worldViewerWindow.heliport.v3.api.channelSessionApi.fetchPositionChannelDetail(this.m_channelId);
            if (resPosChDetail.status !== 'ok') {
                var _resPosChDetail_errorCode;
                this.setError({
                    code: (_resPosChDetail_errorCode = resPosChDetail.errorCode) !== null && _resPosChDetail_errorCode !== void 0 ? _resPosChDetail_errorCode : resPosChDetail.code,
                    data: resPosChDetail.data
                });
                return false;
            }
            const postionChannelDetail = resPosChDetail.data.position_channel;
            this.positionChannel = postionChannelDetail;
            return true;
        } catch (error) {
            this.setError({
                code: '400',
                data: error
            });
            return false;
        }
    }
    async getPlayerList() {
        const updateResult = await this.refresh();
        if (updateResult && this.positionChannel && this.positionChannel.channel_sessions) {
            // @ts-ignore
            return this.positionChannel.channel_sessions.map((channelSession)=>{
                const playerInfoDetail = converChannelSessionToPlayerInfo(channelSession);
                return new CHeliChsPlayerInfo(playerInfoDetail);
            });
        } else {
            return [];
        }
    }
    async getLiveChannelList() {
        debugLog('[ CHeliCarnelianSmcnPosChannel ] no implementation. ');
        return null;
    }
    getPositionChannelDetail() {
        return this.positionChannel;
    }
    constructor(parent, positionChannel){
        _defineProperty(this, "m_parent", void 0);
        _defineProperty(this, "m_channelId", void 0);
        _defineProperty(this, "m_channelType", void 0);
        _defineProperty(this, "positionChannel", void 0);
        _defineProperty(this, "m_errorCode", null);
        _defineProperty(this, "m_errorData", null);
        _defineProperty(this, "m_allowMultiVoiceChannel", void 0);
        this.m_parent = parent;
        this.m_channelId = null;
        this.m_channelType = null;
        this.positionChannel = positionChannel;
        if (positionChannel) {
            this.m_channelId = positionChannel.channel_id;
            this.m_channelType = positionChannel.channel_type;
            this.m_allowMultiVoiceChannel = positionChannel.allow_multi_voice_channel;
        }
    }
}
export class CHeliCarnelianSmcnVoiceChannel {
    isConnected() {
        if (worldViewerWindow.smcnClient && worldViewerWindow.smcnClient.isConnected) {
            return true;
        }
        return false;
    }
    getChannelId() {
        return this.m_channelId || '';
    }
    getErrorCode() {
        return this.m_errorCode;
    }
    getErrorData() {
        return this.m_errorData;
    }
    setError({ code , data  }) {
        this.m_errorCode = code;
        this.m_errorData = data;
    }
    isValid() {
        return this.m_errorCode === null && this.m_errorData === null;
    }
    getValue(key) {
        if (this.voiceChannel) {
            // @ts-ignore
            return this.voiceChannel[key];
        }
        return undefined;
    }
    async join(pIHeliMic) {
        var _this_m_channelId;
        console.log('CarnelianSmcn joinVoiceChannel start:', pIHeliMic);
        const currentPosCh = this.m_parent.getCurrentPositionChannel();
        // 座標チャンネルに接続済みか判定
        console.log(currentPosCh === null || currentPosCh === void 0 ? void 0 : currentPosCh.isConnected());
        if (!currentPosCh || !currentPosCh.isConnected()) {
            console.warn('Could not connect VoCh. connect PosCh first.');
            return false;
        }
        // 音声チャンネルが接続中の座標チャンネルの親か判定
        if (!((_this_m_channelId = this.m_channelId) === null || _this_m_channelId === void 0 ? void 0 : _this_m_channelId.startsWith(currentPosCh.getChannelId()))) {
            console.warn('Could not connect VoCh. connect diffrent parent PosCh.');
            return false;
        }
        try {
            const resEntryVoCh = await worldViewerWindow.heliport.v3.api.channelSessionApi.enterVoiceChannel(this.m_channelId);
            if (resEntryVoCh.status !== 'ok') {
                var _resEntryVoCh_errorCode;
                // 入室エラー
                this.setError({
                    code: (_resEntryVoCh_errorCode = resEntryVoCh.errorCode) !== null && _resEntryVoCh_errorCode !== void 0 ? _resEntryVoCh_errorCode : resEntryVoCh.code,
                    data: resEntryVoCh.data
                });
                return false;
            }
            this.m_parent.setCurrentVoiceChannel(this);
            this.m_isGlobal = false;
            const connectResult = await this.m_parent.joinVoiceRtc(pIHeliMic);
            if (connectResult) {
                console.log('CarnelianSmcn joinVoiceChannel done');
            }
            return connectResult;
        } catch (error) {
            const currentVoCh = this.m_parent.getCurrentVoiceChannel();
            if (currentVoCh && currentVoCh.getChannelId() === this.m_channelId) {
                this.leave();
            }
            this.setError({
                code: '400',
                data: error
            });
            return false;
        }
    }
    async leave() {
        var // 音声チャンネルからの退出を通知
        _this_m_parent_m_IHeliNetworkCallback, _this_m_parent_m_IHeliNetworkCallback1;
        try {
            const resLeaveVosCh = await worldViewerWindow.heliport.v3.api.channelSessionApi.leaveVoiceChannel();
            if (resLeaveVosCh.status !== 'ok') {
                var _resLeaveVosCh_errorCode;
                this.setError({
                    code: (_resLeaveVosCh_errorCode = resLeaveVosCh.errorCode) !== null && _resLeaveVosCh_errorCode !== void 0 ? _resLeaveVosCh_errorCode : resLeaveVosCh.code,
                    data: resLeaveVosCh.data
                });
                return false;
            }
        } catch (error) {
            this.setError({
                code: '400',
                data: error
            });
            return false;
        }
        this.m_parent.setCurrentVoiceChannel(null);
        this.smcnLeaveGroup();
        (_this_m_parent_m_IHeliNetworkCallback = this.m_parent.m_IHeliNetworkCallback) === null || _this_m_parent_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_parent_m_IHeliNetworkCallback.OnNetVoiceDisconnected();
        // デフォルトグループにする
        this.m_isGlobal = true;
        this.m_parent.setCurrentVoiceChannel(this.m_parent.m_SMCNDefaultVoiceChannel);
        const channelSessionJwt = (await worldViewerWindow.heliport.v3.api.channelSessionApi.getChannelSessionJwt()).data;
        const decodeJwt = parseJwt(channelSessionJwt);
        (_this_m_parent_m_IHeliNetworkCallback1 = this.m_parent.m_IHeliNetworkCallback) === null || _this_m_parent_m_IHeliNetworkCallback1 === void 0 ? void 0 : _this_m_parent_m_IHeliNetworkCallback1.OnNetVoiceConnected(decodeJwt.channel_session_code);
        return true;
    }
    async update(params) {
        try {
            const result = await worldViewerWindow.heliport.v3.api.channelSessionApi.updateVoiceChannel(this.m_channelId, params.channelType, params.name, params.description);
            if (result.status !== 'ok') {
                var _result_errorCode;
                this.setError({
                    code: (_result_errorCode = result.errorCode) !== null && _result_errorCode !== void 0 ? _result_errorCode : result.code,
                    data: result.data
                });
                return false;
            }
            this.voiceChannel = result.data.voice_channel;
            return true;
        } catch (error) {
            this.setError({
                code: '400',
                data: error
            });
            return false;
        }
    }
    async refresh() {
        try {
            const resVoiceChDetail = await worldViewerWindow.heliport.v3.api.channelSessionApi.fetchVoiceChannelDetail(this.m_channelId);
            if (resVoiceChDetail.status !== 'ok') {
                var _resVoiceChDetail_errorCode;
                this.setError({
                    code: (_resVoiceChDetail_errorCode = resVoiceChDetail.errorCode) !== null && _resVoiceChDetail_errorCode !== void 0 ? _resVoiceChDetail_errorCode : resVoiceChDetail.code,
                    data: resVoiceChDetail.data
                });
                return false;
            }
            const voiceChannelDetail = resVoiceChDetail.data.voice_channel;
            this.voiceChannel = voiceChannelDetail;
            return true;
        } catch (error) {
            this.setError({
                code: '400',
                data: error
            });
            return false;
        }
    }
    async getPlayerList() {
        const updateResult = await this.refresh();
        if (updateResult && this.voiceChannel && this.voiceChannel.channel_sessions) {
            // @ts-ignore
            return this.voiceChannel.channel_sessions.map((channelSession)=>{
                const playerInfoDetail = converChannelSessionToPlayerInfo(channelSession);
                return new CHeliChsPlayerInfo(playerInfoDetail);
            });
        } else {
            return [];
        }
    }
    // グループの場合:false、デフォルトグループの場合:true
    isGlobal() {
        return this.m_isGlobal;
    }
    // worldIdがnullの場合は、現在所属中のworldとなる(connect時に指定したworldIdと同じ)
    async smcnJoinGroup(worldId, groupId) {
        try {
            // ユーザをグループに入れる
            await worldViewerWindow.smcnClient.joinGroup(worldId, groupId);
        } catch (error) {
            console.error(`[CHeliCarnelianSmcn] joinGroup: ${error}`);
        }
    }
    // グループから退室する、既にデフォルトグループの場合、退室処理はスキップされる
    async smcnLeaveGroup() {
        if (worldViewerWindow.smcnClient) {
            try {
                await worldViewerWindow.smcnClient.leaveGroup();
            } catch (error) {
                console.error(`[smcnClient] leaveGroup: ${error}`);
                alert(`[smcnClient] leaveGroup: ${error}`);
            }
        }
    }
    constructor(parent, voiceChannelDetail){
        _defineProperty(this, "m_parent", void 0);
        _defineProperty(this, "m_channelId", void 0);
        _defineProperty(this, "m_channelType", void 0);
        _defineProperty(this, "voiceChannel", void 0);
        _defineProperty(this, "m_errorCode", null);
        _defineProperty(this, "m_errorData", null);
        _defineProperty(this, "m_isGlobal", false);
        this.m_parent = parent;
        this.voiceChannel = voiceChannelDetail;
        this.m_channelId = voiceChannelDetail ? voiceChannelDetail.channel_id : null;
        this.m_channelType = voiceChannelDetail ? voiceChannelDetail.channel_type : null;
        this.m_isGlobal = voiceChannelDetail ? voiceChannelDetail.is_global : false;
    }
}
export class CHeliCarnelianSmcnLiveChannel {
    isConnected() {
        return !!(worldViewerWindow.agoraLiveClient && worldViewerWindow.agoraLiveClient.ChannelName() === `live__${this.m_channelId}`);
    }
    getChannelId() {
        return this.m_channelId || '';
    }
    getErrorCode() {
        return this.m_errorCode;
    }
    getErrorData() {
        return this.m_errorData;
    }
    setError({ code , data  }) {
        this.m_errorCode = code;
        this.m_errorData = data;
    }
    isValid() {
        return this.m_errorCode === null && this.m_errorData === null;
    }
    getValue(key) {
        if (this.liveChannel) {
            // @ts-ignore
            return this.liveChannel[key];
        }
        return undefined;
    }
    async joinHost(pIHeliMic) {
        // Smcnの場合、HostとしてJoinしても、マイクは使わないので、マイク関係の処理はオミット
        console.log('CarnelianAgora joinliveChannel start:', pIHeliMic);
        try {
            const resEntryVoCh = await worldViewerWindow.heliport.v3.api.channelSessionApi.enterLiveChannel(this.m_channelId);
            if (resEntryVoCh.status !== 'ok') {
                var _resEntryVoCh_errorCode;
                // 入室エラー
                this.setError({
                    code: (_resEntryVoCh_errorCode = resEntryVoCh.errorCode) !== null && _resEntryVoCh_errorCode !== void 0 ? _resEntryVoCh_errorCode : resEntryVoCh.code,
                    data: resEntryVoCh.data
                });
                return false;
            }
            const channelSessionJwt = (await worldViewerWindow.heliport.v3.api.channelSessionApi.getChannelSessionJwt()).data;
            console.log('VoCh join genericRtcToken channelSessionJwt', parseJwt(channelSessionJwt));
            const type = 'agora';
            const mode = 'live';
            const res = await worldViewerWindow.heliport.v3.api.genericRtcToken.getToken(channelSessionJwt, type, mode, false);
            const token = res.data;
            console.log('joinliveChannel genericRtcToken jsonToken', token);
            const agoraToken = token.token;
            const agoraAppId = token.app_id;
            const agoraChannelId = token.room_id;
            // TODO agoraUserID と CRP objectIDの変換テーブル
            const agoraUserId = parseInt(token.user_id);
            this.m_parent.setCurrentLiveChannel(this);
            // currentLiveChannelがnullの場合は何もしない
            // 入室中に退室が走るケースがあるため、それのケア用
            if (!this.m_parent.getCurrentLiveChannel()) {
                var _this_m_parent_m_IHeliNetworkCallback;
                (_this_m_parent_m_IHeliNetworkCallback = this.m_parent.m_IHeliNetworkCallback) === null || _this_m_parent_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_parent_m_IHeliNetworkCallback.OnNetLiveDisconnected();
                return false;
            }
            const micEnabled = false;
            worldViewerWindow.agoraLiveClient.setLocalAgoraTrack(this.m_parent.m_localAgoraTrack);
            await worldViewerWindow.agoraLiveClient.joinLiveHostByToken(agoraAppId, agoraToken, agoraChannelId, agoraUserId, micEnabled);
            console.log('CarnelianAgora joinliveChannel done');
            return true;
        } catch (error) {
            console.error(error);
            const currentLiveCh = this.m_parent.getCurrentLiveChannel();
            // 入室中に退室が走るケースがあるため、それのケア用
            if (!currentLiveCh) {
                var _this_m_parent_m_IHeliNetworkCallback1;
                (_this_m_parent_m_IHeliNetworkCallback1 = this.m_parent.m_IHeliNetworkCallback) === null || _this_m_parent_m_IHeliNetworkCallback1 === void 0 ? void 0 : _this_m_parent_m_IHeliNetworkCallback1.OnNetLiveDisconnected();
            }
            console.log(currentLiveCh);
            if (currentLiveCh && currentLiveCh.getChannelId() === this.m_channelId) {
                this.leave();
            }
            this.setError({
                code: '400',
                data: error
            });
            return false;
        }
    }
    async joinAudience() {
        try {
            const liveChannelCode = this.m_channelId;
            const res = await worldViewerWindow.heliport.v3.api.channelSessionApi.fetchLiveChannelAudienceJwt(liveChannelCode);
            if (res.status !== 'ok') {
                // 入室エラー
                const currentLiveCh = this.m_parent.getCurrentLiveChannel();
                if (currentLiveCh && currentLiveCh.getChannelId() === this.m_channelId) {
                    this.leave();
                }
                var _res_errorCode;
                this.setError({
                    code: (_res_errorCode = res.errorCode) !== null && _res_errorCode !== void 0 ? _res_errorCode : null,
                    data: res.data
                });
                return false;
            }
            const type = 'agora';
            const resGetToken = await worldViewerWindow.heliport.v3.api.genericRtcToken.getToken(res.data.jwt, type, 'live', false);
            console.log(resGetToken);
            const token = resGetToken.data;
            const agoraToken = token.token;
            const agoraAppId = token.app_id;
            const agoraChannelId = token.room_id;
            const agoraUserId = parseInt(token.user_id);
            const latencyLevel = 1;
            this.m_parent.setCurrentLiveChannel(this);
            // currentLiveChannelがnullの場合は何もしない
            // 入室中に退室が走るケースがあるため、それのケア用
            if (!this.m_parent.getCurrentLiveChannel()) {
                var _this_m_parent_m_IHeliNetworkCallback;
                (_this_m_parent_m_IHeliNetworkCallback = this.m_parent.m_IHeliNetworkCallback) === null || _this_m_parent_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_parent_m_IHeliNetworkCallback.OnNetLiveDisconnected();
                return false;
            }
            console.log('CarnelianAgora joinLiveChannel audience start');
            await worldViewerWindow.agoraLiveClient.joinLiveAudienceByToken(agoraAppId, agoraToken, agoraChannelId, agoraUserId, latencyLevel);
            // TODO: ここでコールバックを呼び出すよりも、agoraClientのイベントから呼び出したい
            // this.m_parent.m_IHeliNetworkCallback?.OnNetLiveConnected(agoraUserId);
            console.log('CarnelianAgora joinLiveChannel audience done');
            return true;
        } catch (error) {
            const currentLiveCh = this.m_parent.getCurrentLiveChannel();
            // 入室中に退室が走るケースがあるため、それのケア用
            if (!currentLiveCh) {
                var _this_m_parent_m_IHeliNetworkCallback1;
                (_this_m_parent_m_IHeliNetworkCallback1 = this.m_parent.m_IHeliNetworkCallback) === null || _this_m_parent_m_IHeliNetworkCallback1 === void 0 ? void 0 : _this_m_parent_m_IHeliNetworkCallback1.OnNetLiveDisconnected();
            }
            if (currentLiveCh && currentLiveCh.getChannelId() === this.m_channelId) {
                this.leave();
            }
            this.setError({
                code: '400',
                data: error
            });
            return false;
        }
    }
    // eslint-disable-next-line no-undef
    async changeMic(pIHeliMic) {
        await worldViewerWindow.agoraLiveClient.initLocalTrack({
            microphoneId: pIHeliMic.deviceId,
            cameraId: false
        });
    }
    async leave() {
        var _this_m_parent_m_IHeliNetworkCallback;
        if (this.isPresenter()) {
            try {
                const resLeaveLiveCh = await worldViewerWindow.heliport.v3.api.channelSessionApi.leaveLiveChannel();
                if (resLeaveLiveCh.status !== 'ok') {
                    var _resLeaveLiveCh_errorCode;
                    this.setError({
                        code: (_resLeaveLiveCh_errorCode = resLeaveLiveCh.errorCode) !== null && _resLeaveLiveCh_errorCode !== void 0 ? _resLeaveLiveCh_errorCode : resLeaveLiveCh.code,
                        data: resLeaveLiveCh.data
                    });
                    return false;
                }
            } catch (error) {
                this.setError({
                    code: '400',
                    data: error
                });
                return false;
            }
        }
        // もしライブ配信再生途中で、leaveした場合、配信を停止する
        if (this.m_parent.isPlayingLiveVideo()) {
            this.m_parent.stopLiveVideo();
        }
        this.m_parent.setCurrentLiveChannel(null);
        this.m_parent.clearLiveVideoSrc();
        if (worldViewerWindow.agoraLiveClient) {
            worldViewerWindow.agoraLiveClient.close();
        }
        (_this_m_parent_m_IHeliNetworkCallback = this.m_parent.m_IHeliNetworkCallback) === null || _this_m_parent_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_parent_m_IHeliNetworkCallback.OnNetLiveVideoEnded();
        return true;
    }
    async refresh() {
        try {
            const result = await worldViewerWindow.heliport.v3.api.channelSessionApi.fetchLiveChannelDetail(this.m_channelId);
            if (result.status !== 'ok') {
                var _result_errorCode;
                this.setError({
                    code: (_result_errorCode = result.errorCode) !== null && _result_errorCode !== void 0 ? _result_errorCode : result.code,
                    data: result.data
                });
                return false;
            }
            const liveChannelDetail = result.data.live_channel;
            this.liveChannel = liveChannelDetail;
            return true;
        } catch (error) {
            this.setError({
                code: '400',
                data: error
            });
            return false;
        }
    }
    async getPlayerList() {
        const updateResult = await this.refresh();
        if (updateResult && this.liveChannel && this.liveChannel.channel_sessions) {
            // @ts-ignore
            return this.liveChannel.channel_sessions.map((channelSession)=>{
                const playerInfoDetail = converChannelSessionToPlayerInfo(channelSession);
                return new CHeliChsPlayerInfo(playerInfoDetail);
            });
        } else {
            return [];
        }
    }
    isPresenter() {
        if (this.isConnected()) {
            return worldViewerWindow.agoraLiveClient.getRole() === 'host';
        }
        return false;
    }
    constructor(parent, liveChannelDetail){
        _defineProperty(this, "m_parent", void 0);
        _defineProperty(this, "m_channelId", void 0);
        _defineProperty(this, "m_channelType", void 0);
        _defineProperty(this, "liveChannel", void 0);
        _defineProperty(this, "m_errorCode", null);
        _defineProperty(this, "m_errorData", null);
        this.m_parent = parent;
        this.liveChannel = liveChannelDetail;
        this.m_channelId = liveChannelDetail ? liveChannelDetail.channel_id : null;
        this.m_channelType = null;
    }
}
export class CHeliCarnelianSmcn {
    initEvent() {
        worldViewerWindow.addEventListener('pagehide', (event)=>{
            // APIへ退出通知
            worldViewerWindow.heliport.v3.api.ingameStateManagerApi.sendLeaveBeacon();
        });
    }
    // 接続
    async connect(configKey) {
        var _this_m_CCrpRegist, _this_m_CChannelSessionApi;
        worldViewerWindow.hel_setText(worldViewerWindow.ETextParamType_SetCRPMode, '1');
        console.log('CarnelianSmcn connect start');
        const CONFIG = worldViewerWindow.getIngameConfig();
        const crpEndPoint = `wss://${CONFIG.CRP_HOST}/ws/${CONFIG.CRP_VERSION}/`;
        const crpType = CONFIG.CRP_TYPE === 'prism' ? 'prism' : 'normal';
        const prismEndpoint = CONFIG.PRISM_HOST ? `https://${CONFIG.PRISM_HOST}/api/${CONFIG.CRP_VERSION}/endpoint` : '';
        const crpFrontOption = {
            connectionType: crpType,
            prismEndpoint: prismEndpoint
        };
        const crpFront = new worldViewerWindow.createCrpFront(crpEndPoint, crpFrontOption);
        setCrpFront(crpFront);
        (_this_m_CCrpRegist = this.m_CCrpRegist) === null || _this_m_CCrpRegist === void 0 ? void 0 : _this_m_CCrpRegist.initialize(crpFront);
        (_this_m_CChannelSessionApi = this.m_CChannelSessionApi) === null || _this_m_CChannelSessionApi === void 0 ? void 0 : _this_m_CChannelSessionApi.startHeartbeat();
        const smcnClient = new worldViewerWindow.SMCNWClient.SMCNWClient(CONFIG.SMCN_API_KEY, null, CONFIG.SMCN_ENV_NAME, CONFIG.SMCN_BASE_SERVER_URL);
        console.debug('init smcnClient', smcnClient);
        //
        // callbacks
        //
        // 自身が入室時のチャンネル一覧更新処理
        const updateVoiceChannelMember = async ()=>{
            // 一旦処理を待ってから行う
            setTimeout(async ()=>{
                const memberidentities = await smcnClient.getGroupMembers();
                for (const identity of memberidentities){
                    var // 音声チャンネルへのJoinを通知
                    _this_m_IHeliNetworkCallback;
                    // identityの仕様変更に伴う修正@付きで来るので@を除外する
                    const tmp_idenity = identity.split('@')[0];
                    const objectId = this.findObjectIdByRtcUserCode(tmp_idenity);
                    const player = this.getPlayer(objectId || '');
                    if (!player) {
                        continue;
                    }
                    (_this_m_IHeliNetworkCallback = this.m_IHeliNetworkCallback) === null || _this_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_IHeliNetworkCallback.OnNetReceiveVoiceJoin(player.getPlayerId(), '');
                }
            }, 5000);
        };
        // サーバに接続(デフォルトグループに接続後もこちら)
        const handleConnected = async (worldId, groupId)=>{
            console.debug(`Connected worldId::${worldId} groupId::${groupId}`);
            await updateVoiceChannelMember();
            const userPosition = {
                x: this.m_UserPosition.x,
                y: this.m_UserPosition.y,
                z: this.m_UserPosition.z
            };
            const userOrientation = {
                x: this.m_UserOrientation.x,
                y: this.m_UserOrientation.y,
                z: this.m_UserOrientation.z,
                w: this.m_UserOrientation.w
            };
            smcnClient.sendUserPosition(userPosition, userOrientation);
            this.setSmcnGroupParam();
        };
        // グループに接続
        const handleGroupConnected = async (worldId, groupId)=>{
            console.debug(`GroupConnected worldId::${worldId} groupId::${groupId}`);
            await updateVoiceChannelMember();
            const userPosition = {
                x: this.m_UserPosition.x,
                y: this.m_UserPosition.y,
                z: this.m_UserPosition.z
            };
            const userOrientation = {
                x: this.m_UserOrientation.x,
                y: this.m_UserOrientation.y,
                z: this.m_UserOrientation.z,
                w: this.m_UserOrientation.w
            };
            smcnClient.sendUserPosition(userPosition, userOrientation);
            this.setSmcnGroupParam();
        };
        // スピーカーモード（特権モード）グループに接続
        const handleSpeakerModeGroupConnected = async (worldId, groupId)=>{
            console.debug(`SpeakerModeGroupConnected worldId::${worldId} groupId::${groupId}`);
            await updateVoiceChannelMember();
            const userPosition = {
                x: this.m_UserPosition.x,
                y: this.m_UserPosition.y,
                z: this.m_UserPosition.z
            };
            const userOrientation = {
                x: this.m_UserOrientation.x,
                y: this.m_UserOrientation.y,
                z: this.m_UserOrientation.z,
                w: this.m_UserOrientation.w
            };
            smcnClient.sendUserPosition(userPosition, userOrientation);
            this.setSmcnGroupParam();
        };
        // サーバから切断
        const handleDisconnected = ()=>{
            console.debug('Disconnected');
        };
        // 他者からグループへの招待を受けた場合の通知
        const handleRequestGroupChange = (worldId, groupId, resolve)=>{
            console.debug(`RequestGroupChange worldId::${worldId} groupId::${groupId}`);
            resolve(true);
        // 自動で招待を受ける設定
        /*
      const autoGroupChangeStatus = document.getElementById('autoGroupChange') as HTMLInputElement;
      if (autoGroupChangeStatus.checked) {
          resolve(true)
          return
      }
      */ // 招待を受けるか否かの確認ダイアログ
        // const result = window.confirm(`ボイスチャットグループから招待を受けました。「world: ${worldId}, group: ${groupId}」`)
        // resolve(result)
        };
        // グループ変更
        const handleStartGroupChange = (worldId, groupId)=>{
            console.debug(`StartGroupChange worldId::${worldId} groupId::${groupId}`);
        };
        // 接続している音声機器の変更
        const handleMediaDevicesChanged = ()=>{
            console.debug('MediaDevicesChanged');
        };
        // 同一グループ内にユーザが接続
        const handleParticipantConnected = (identity)=>{
            var // 音声チャンネルへのJoinを通知
            _this_m_IHeliNetworkCallback;
            console.debug('ParticipantConnected', identity);
            const objectId = this.findObjectIdByRtcUserCode(identity);
            const player = this.getPlayer(objectId || '');
            if (!player) {
                // identityにて、agent-付きがくるが、SmcnSDK側のバグ（そのうち修正される）
                return;
            }
            (_this_m_IHeliNetworkCallback = this.m_IHeliNetworkCallback) === null || _this_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_IHeliNetworkCallback.OnNetReceiveVoiceJoin(player.getPlayerId(), '');
        };
        // 同一グループ内からユーザが切断
        const handleParticipantDisconnected = (identity)=>{
            var // 音声チャンネルからのLeaveを通知
            _this_m_IHeliNetworkCallback;
            console.debug('ParticipantDisconnected', identity);
            const objectId = this.findObjectIdByRtcUserCode(identity);
            const player = this.getPlayer(objectId || '');
            if (!player) {
                // identityにて、agent-付きがくるが、SmcnSDK側のバグ（そのうち修正される）
                return;
            }
            (_this_m_IHeliNetworkCallback = this.m_IHeliNetworkCallback) === null || _this_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_IHeliNetworkCallback.OnNetReceiveVoiceLeave(player.getPlayerId(), '');
        };
        // ローカルトラックパブリッシュ後
        const handleLocalTrackPublished = (localPub)=>{
            console.debug('localTrackPublished', localPub, this.m_SMCNWMediaTrackSettings.inputMute);
            setLocalStream(localPub.publication.track.mediaStream);
            localPub.setMute(this.m_SMCNWMediaTrackSettings.inputMute);
            this.m_SMCNWLocalTrackPublication = localPub;
        };
        // クラウドレンダリング用コンポーネントの接続後
        const handleAgentConnected = ()=>{
            console.debug('Agent Connected');
        };
        // 再生する音声ストリームがパブリッシュ後
        const handleAgentTrackPublished = (remotePub)=>{
            console.debug('agentTrackPublished', remotePub);
            remotePub.setEnabled(this.m_SMCNWMediaTrackSettings.outputEnable);
        };
        // 再生する音声ストリームの取得に成功後
        const handleAgentTrackSubscribed = (remotePub, audioElements)=>{
            console.debug('agentTrackSubscribed', remotePub, audioElements);
            remotePub.setMute(this.m_SMCNWMediaTrackSettings.outputMute);
            this.m_SMCNWRemoteTrackPublication = remotePub;
        };
        // クラウドレンダリング用コンポーネントの切断後
        const handleAgentDisconnected = ()=>{
            console.debug('Agent Disconnected');
            // SDKの更新により再接続機能の追加予定
            if (window.confirm('SmcnClientクラウドレンダリングとの接続が切断されました、復帰のためにはページをリロードしてください')) {
                location.reload();
            }
        };
        // 再生する音声ストリームの切断後
        const handleAgentAudioStopped = ()=>{
            console.debug('Agent Audio stopped');
        };
        smcnClient.on(worldViewerWindow.SMCNWClient.SMCNWEvent.Connected, handleConnected);
        smcnClient.on(worldViewerWindow.SMCNWClient.SMCNWEvent.GroupConnected, handleGroupConnected);
        smcnClient.on(worldViewerWindow.SMCNWClient.SMCNWEvent.SpeakerModeGroupConnected, handleSpeakerModeGroupConnected);
        smcnClient.on(worldViewerWindow.SMCNWClient.SMCNWEvent.Disconnected, handleDisconnected);
        smcnClient.on(worldViewerWindow.SMCNWClient.SMCNWEvent.RequestGroupChange, handleRequestGroupChange);
        smcnClient.on(worldViewerWindow.SMCNWClient.SMCNWEvent.StartGroupChange, handleStartGroupChange);
        smcnClient.on(worldViewerWindow.SMCNWClient.SMCNWEvent.MediaDevicesChanged, handleMediaDevicesChanged);
        smcnClient.on(worldViewerWindow.SMCNWClient.SMCNWEvent.ParticipantConnected, handleParticipantConnected);
        smcnClient.on(worldViewerWindow.SMCNWClient.SMCNWEvent.ParticipantDisconnected, handleParticipantDisconnected);
        smcnClient.on(worldViewerWindow.SMCNWClient.SMCNWEvent.LocalTrackPublished, handleLocalTrackPublished);
        smcnClient.on(worldViewerWindow.SMCNWClient.SMCNWEvent.AgentConnected, handleAgentConnected);
        smcnClient.on(worldViewerWindow.SMCNWClient.SMCNWEvent.AgentTrackPublished, handleAgentTrackPublished);
        smcnClient.on(worldViewerWindow.SMCNWClient.SMCNWEvent.AgentTrackSubscribed, handleAgentTrackSubscribed);
        smcnClient.on(worldViewerWindow.SMCNWClient.SMCNWEvent.AgentDisconnected, handleAgentDisconnected);
        smcnClient.on(worldViewerWindow.SMCNWClient.SMCNWEvent.AgentAudioStopped, handleAgentAudioStopped);
        // 定期的に座標を監視する
        const intervalSendUserPosition = setInterval(()=>{
            try {
                var _this_m_IHeliNetworkCallback;
                if (!smcnClient.isConnected) {
                    return;
                }
                (_this_m_IHeliNetworkCallback = this.m_IHeliNetworkCallback) === null || _this_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_IHeliNetworkCallback.OnNetRequestCurrentLocalTransform();
                const userPosition = {
                    x: this.m_UserPosition.x,
                    y: this.m_UserPosition.y,
                    z: this.m_UserPosition.z
                };
                const userOrientation = {
                    x: this.m_UserOrientation.x,
                    y: this.m_UserOrientation.y,
                    z: this.m_UserOrientation.z,
                    w: this.m_UserOrientation.w
                };
                // 変わってないなら送らない
                if (userPosition.x === this.m_CurrentUserPosition.x && userPosition.y === this.m_CurrentUserPosition.y && userPosition.z === this.m_CurrentUserPosition.z && userOrientation.x === this.m_CurrentUserOrientation.x && userOrientation.y === this.m_CurrentUserOrientation.y && userOrientation.z === this.m_CurrentUserOrientation.z && userOrientation.w === this.m_CurrentUserOrientation.w) {
                    return;
                }
                smcnClient.sendUserPosition(userPosition, userOrientation);
                this.m_CurrentUserPosition = userPosition;
                this.m_CurrentUserOrientation = userOrientation;
            } catch (error) {
                console.error(`[smcnClient] sendUserPosition: ${error}`);
            }
        }, 500);
        window.addEventListener('beforeunload', ()=>{
            var _this_m_CChannelSessionApi;
            (_this_m_CChannelSessionApi = this.m_CChannelSessionApi) === null || _this_m_CChannelSessionApi === void 0 ? void 0 : _this_m_CChannelSessionApi.stopHeartbeat();
            worldViewerWindow.crpFront.close();
            try {
                smcnClient.disconnect();
            } catch (error) {
                console.error(`[smcnClient] beforeunload disconnect: ${error}`);
                alert(`[smcnClient] beforeunload disconnect: ${error}`);
            }
            clearInterval(intervalSendUserPosition);
        });
        window.addEventListener('pagehide', ()=>{
            var _this_m_CChannelSessionApi;
            (_this_m_CChannelSessionApi = this.m_CChannelSessionApi) === null || _this_m_CChannelSessionApi === void 0 ? void 0 : _this_m_CChannelSessionApi.stopHeartbeat();
            worldViewerWindow.crpFront.close();
            try {
                smcnClient.disconnect();
            } catch (error) {
                console.error(`[smcnClient] pagehide disconnect: ${error}`);
                alert(`[smcnClient] pagehide disconnect: ${error}`);
            }
            clearInterval(intervalSendUserPosition);
        });
        worldViewerWindow.smcnClient = smcnClient;
        // 開発用
        // 何かしらの資材
        const isLive = true;
        if (isLive) {
            this.initLiveClient();
        }
        console.log('CarnelianSmcn connect done');
        return true;
    }
    disconnect() {
        console.log('CarnelianSmcn disconnect now');
        const currentPosCh = this.getCurrentPositionChannel();
        if (currentPosCh) {
            currentPosCh.leave();
        }
        closeLocalStream();
        console.log('CarnelianSmcn disconnect done');
        if (worldViewerWindow.smcnClient) {
            try {
                worldViewerWindow.smcnClient.disconnect();
            } catch (error) {
                console.error(`[smcnClient] CarnelianSmcn disconnect: ${error}`);
                alert(`[smcnClient] CarnelianSmcn disconnect: ${error}`);
            }
        }
    }
    isConnected() {
        const crpFront = getCrpFront();
        if (crpFront && crpFront.isJoined) {
            return true;
        }
        return false;
    }
    isConnectedPositionChannel() {
        const crpFront = getCrpFront();
        const currentPosCh = this.getCurrentPositionChannel();
        if (crpFront && crpFront.isEntered && currentPosCh && currentPosCh.isConnected()) {
            return true;
        }
        return false;
    }
    setSmcnGroupParam() {
        const CONFIG = worldViewerWindow.getIngameConfig();
        const groupParams = {
            filters: [],
            attenuationParams: {
                minDistance: CONFIG.SMCN_GROUP_ATTENUATION_MIN_DISTANCE,
                maxDistance: CONFIG.SMCN_GROUP_ATTENUATION_MAX_DISTANCE,
                rollOffFactor: CONFIG.SMCN_GROUP_ATTENUATION_ROLL_OFF_FACTOR,
                maxAttenuateDiff: CONFIG.SMCN_GROUP_ATTENUATION_MAX_ATTENUATE_DIFF
            }
        };
        if (CONFIG.SMCN_GROUP_USE_FILTER === "true") {
            const filter = {
                type: CONFIG.SMCN_GROUP_FILTER_TYPE,
                params: {
                    cutoff: CONFIG.SMCN_GROUP_FILTER_CUTOFF,
                    resonance: CONFIG.SMCN_GROUP_FILTER_RESONANCE
                }
            };
            groupParams.filters.push(filter);
        }
        worldViewerWindow.smcnClient.setGroupParams(groupParams);
    }
    // ライフサイクル定義
    afterJoinPosRtc() {
        const currentPosCh = this.getCurrentPositionChannel();
        // 座標Chが非MultiVCの場合、音声RTCに自動接続する
        if (!(currentPosCh === null || currentPosCh === void 0 ? void 0 : currentPosCh.isMultiVc())) {
            this.joinVoiceRtc(null);
        }
        this.startOwnershipHeartbeatInterval();
    }
    afterJoinVoiceRtc() {}
    afterLeavePosRtc() {
        this.stopOwnershipHeartbeatInterval();
    }
    afterLeaveVoiceRtc() {}
    // 音声RTC接続処理
    async joinVoiceRtc(pIHeliMic) {
        const channelSessionJwt = (await worldViewerWindow.heliport.v3.api.channelSessionApi.getChannelSessionJwt()).data;
        const decodeJwt = parseJwt(channelSessionJwt);
        const voCh = this.getCurrentVoiceChannel();
        if (voCh) {
            var _this_m_IHeliNetworkCallback;
            await voCh.smcnJoinGroup(decodeJwt.position_channel_code, voCh.m_channelId || '');
            (_this_m_IHeliNetworkCallback = this.m_IHeliNetworkCallback) === null || _this_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_IHeliNetworkCallback.OnNetVoiceConnected(decodeJwt.channel_session_code);
        }
        return true;
    }
    getPeerId() {
        const crpFront = getCrpFront();
        if (!crpFront || !crpFront.ownObjectId) {
            return '';
        }
        return crpFront.ownObjectId;
    }
    // 仮コード
    leavePosChannel() {
        return;
    }
    // @ts-ignore
    async initLocalMicInput(deviceId) {
        const localMediaStream = getLocalStream();
        if (localMediaStream === undefined) {
            console.error(`[initLocalMicInput] localMediaStream: undefined`);
            return false;
        }
        console.log('initLocalMicInput deviceId', deviceId, localMediaStream === null || localMediaStream === void 0 ? void 0 : localMediaStream.getAudioTracks()[0].label);
        try {
            const devices = await worldViewerWindow.smcnClient.getLocalDevices('audioinput', true);
            devices.forEach((device)=>{
                if (device.label === (localMediaStream === null || localMediaStream === void 0 ? void 0 : localMediaStream.getAudioTracks()[0].label)) {
                    deviceId = device.deviceId;
                }
            });
            console.log('initLocalMicInput deviceId Selected After', deviceId);
            const result = await worldViewerWindow.smcnClient.switchActiveDevice('audioinput', deviceId); // change active device
            if (!result) {
                throw new Error(`Change Device Error`);
            }
            this.m_Mic_ready = true;
            return true;
        } catch (error) {
            console.error(`[smcnClient] switchActiveDevice: ${error}`);
            alert(`[smcnClient] switchActiveDevice: ${error}`);
            return false;
        }
    }
    async setMicEnabled(enabled) {
        if (this.m_SMCNWLocalTrackPublication) {
            try {
                this.m_SMCNWLocalTrackPublication.setMute(!enabled);
            } catch (err) {
                // trackがない場合でも、処理を継続する
                console.warn(err);
            }
            this.m_SMCNWMediaTrackSettings.inputMute = !enabled;
        } else {
            await worldViewerWindow.smcnClient.publishLocalTrack();
        }
    }
    async setLiveMicEnabled(enabled) {
        this.setMicEnabled(enabled);
    }
    // マイク許可状態
    getMicPermissionState() {
        return this.m_MicPermissionState;
    }
    setCurrentLocalTransform(param) {
        this.m_UserPosition.x = param.player.pos.x;
        this.m_UserPosition.y = param.player.pos.y;
        this.m_UserPosition.z = param.player.pos.z;
        this.m_UserOrientation.x = param.camera.rotate.x;
        this.m_UserOrientation.y = param.camera.rotate.y;
        this.m_UserOrientation.z = param.camera.rotate.z;
        this.m_UserOrientation.w = param.camera.rotate.w;
    }
    async checkMicPermissionState() {
        const prevPermissionState = this.m_MicPermissionState;
        try {
            const permissionStatus = await navigator.permissions.query({
                // eslint-disable-next-line no-undef
                name: 'microphone'
            });
            if (permissionStatus.state === 'denied') {
                this.m_MicPermissionState = EHeliMicPermissionState.Denied;
            } else if (permissionStatus.state === 'granted') {
                this.m_MicPermissionState = EHeliMicPermissionState.Granted;
            } else if (permissionStatus.state === 'prompt') {
                this.m_MicPermissionState = EHeliMicPermissionState.Prompt;
            } else {
                this.m_MicPermissionState = EHeliMicPermissionState.Prompt;
            }
        } catch (e) {
            // Firefoxでは'microphone'に対応していないので、LocalStreamの設定状態で判別する
            if (getLocalStream() !== undefined) {
                this.m_MicPermissionState = EHeliMicPermissionState.Granted;
            } else {
                this.m_MicPermissionState = EHeliMicPermissionState.Denied;
            }
        }
        // iOSではマイク不許可時にDeniedではなくPromptしか返ってこず、マイク許可を促すCanvasが出なくなってしまうのでDeniedにする
        if (worldViewerWindow.hel_isSafari() && this.m_MicPermissionState === EHeliMicPermissionState.Prompt) {
            this.m_MicPermissionState = EHeliMicPermissionState.Denied;
        }
        // 状態変更によるコールバック呼び出し
        if (this.m_IHeliNetworkCallback != null && prevPermissionState !== this.m_MicPermissionState) {
            this.m_IHeliNetworkCallback.OnChangedMicPermissionState(this.m_MicPermissionState);
        }
    }
    // 座標チャネル
    // @ts-ignore
    async createPosChannel(spatiumCode, worldCode, params) {
        try {
            const resCreatePosChannel = await worldViewerWindow.heliport.v3.api.channelSessionApi.createPositionChannel(spatiumCode, worldCode, params.channelType, params.name, params.description);
            if (resCreatePosChannel.status !== 'ok') {
                const iHeliPositionChannel = new CHeliCarnelianSmcnPosChannel(this, null);
                var _resCreatePosChannel_errorCode;
                iHeliPositionChannel.setError({
                    code: (_resCreatePosChannel_errorCode = resCreatePosChannel.errorCode) !== null && _resCreatePosChannel_errorCode !== void 0 ? _resCreatePosChannel_errorCode : resCreatePosChannel.code,
                    data: resCreatePosChannel.data
                });
                return iHeliPositionChannel;
            }
            const postionChannelDetail = resCreatePosChannel.data.position_channel;
            const iHeliPositionChannel = new CHeliCarnelianSmcnPosChannel(this, postionChannelDetail);
            return iHeliPositionChannel;
        } catch (error) {
            const iHeliPositionChannel = new CHeliCarnelianSmcnPosChannel(this, null);
            iHeliPositionChannel.setError({
                code: '400',
                data: error
            });
            return iHeliPositionChannel;
        }
    }
    async getPosChannel(channelid) {
        try {
            const resPosChDetail = await worldViewerWindow.heliport.v3.api.channelSessionApi.fetchPositionChannelDetail(channelid);
            if (resPosChDetail.status !== 'ok') {
                const iHeliPositionChannel = new CHeliCarnelianSmcnPosChannel(this, null);
                var _resPosChDetail_errorCode;
                iHeliPositionChannel.setError({
                    code: (_resPosChDetail_errorCode = resPosChDetail.errorCode) !== null && _resPosChDetail_errorCode !== void 0 ? _resPosChDetail_errorCode : resPosChDetail.code,
                    data: resPosChDetail.data
                });
                // @ts-ignore
                return iHeliPositionChannel;
            }
            const postionChannelDetail = resPosChDetail.data.position_channel;
            // @ts-ignore
            return new CHeliCarnelianSmcnPosChannel(this, postionChannelDetail);
        } catch (error) {
            const iHeliPositionChannel = new CHeliCarnelianSmcnPosChannel(this, null);
            iHeliPositionChannel.setError({
                code: '400',
                data: error
            });
            // @ts-ignore
            return iHeliPositionChannel;
        }
    }
    async getPosChannelList(spatiumcode, worldCode, params) {
        try {
            const excludeEmptyChannelFlg = params.excludeEmptyChannelFlg !== undefined && params.excludeEmptyChannelFlg !== null ? params.excludeEmptyChannelFlg : true;
            const resPosChList = await worldViewerWindow.heliport.v3.api.channelSessionApi.fetchWorldPositionChannelList(spatiumcode, worldCode, excludeEmptyChannelFlg);
            if (resPosChList.status !== 'ok') {
                const iHeliPosChList = new IHeliCarnelianSmcnPosChannelList();
                var _resPosChList_errorCode;
                iHeliPosChList.setError({
                    code: (_resPosChList_errorCode = resPosChList.errorCode) !== null && _resPosChList_errorCode !== void 0 ? _resPosChList_errorCode : resPosChList.code,
                    data: resPosChList.data
                });
                return iHeliPosChList;
            }
            const posChList = resPosChList.data.position_channels.map((postionChannel)=>{
                return new CHeliCarnelianSmcnPosChannel(this, postionChannel);
            });
            const offset = params.offset ? params.offset : 0;
            const limit = params.limit ? params.limit : null;
            return new IHeliCarnelianSmcnPosChannelList(posChList, offset, limit);
        } catch (error) {
            const iHeliPosChList = new IHeliCarnelianSmcnPosChannelList();
            iHeliPosChList.setError({
                code: '400',
                data: error
            });
            return iHeliPosChList;
        }
    }
    setCurrentPositionChannel(posionChannel) {
        this.m_current_position_channel = posionChannel;
    }
    getCurrentPositionChannel() {
        // @ts-ignore
        return this.m_current_position_channel;
    }
    // ボイスチャネル
    async createVoiceChannel(posionChannelCode, params) {
        try {
            const resCreateVoChannel = await worldViewerWindow.heliport.v3.api.channelSessionApi.createVoiceChannel(posionChannelCode, params.channelType, params.name, params.description);
            if (resCreateVoChannel.status !== 'ok') {
                const iHeliVoiceChannel = new CHeliCarnelianSmcnVoiceChannel(this, null);
                var _resCreateVoChannel_errorCode;
                iHeliVoiceChannel.setError({
                    code: (_resCreateVoChannel_errorCode = resCreateVoChannel.errorCode) !== null && _resCreateVoChannel_errorCode !== void 0 ? _resCreateVoChannel_errorCode : resCreateVoChannel.code,
                    data: resCreateVoChannel.data
                });
                // @ts-ignore
                return iHeliVoiceChannel;
            }
            const voiceChannelDetail = resCreateVoChannel.data.voice_channel;
            // @ts-ignore
            return new CHeliCarnelianSmcnVoiceChannel(this, voiceChannelDetail);
        } catch (error) {
            const iHeliVoiceChannel = new CHeliCarnelianSmcnVoiceChannel(this, null);
            iHeliVoiceChannel.setError({
                code: '400',
                data: error
            });
            // @ts-ignore
            return iHeliVoiceChannel;
        }
    }
    async getVoiceChannel(channelid) {
        try {
            const resVoChDetail = await worldViewerWindow.heliport.v3.api.channelSessionApi.fetchVoiceChannelDetail(channelid);
            if (resVoChDetail.status !== 'ok') {
                const iHeliVoitionChannel = new CHeliCarnelianSmcnVoiceChannel(this, null);
                var _resVoChDetail_errorCode;
                iHeliVoitionChannel.setError({
                    code: (_resVoChDetail_errorCode = resVoChDetail.errorCode) !== null && _resVoChDetail_errorCode !== void 0 ? _resVoChDetail_errorCode : resVoChDetail.code,
                    data: resVoChDetail.data
                });
                // @ts-ignore
                return iHeliVoitionChannel;
            }
            console.log(resVoChDetail);
            const voiceChannelDetail = resVoChDetail.data.voice_channel;
            console.log(voiceChannelDetail);
            // @ts-ignore
            return new CHeliCarnelianSmcnVoiceChannel(this, voiceChannelDetail);
        } catch (error) {
            const iHeliVoiceChannel = new CHeliCarnelianSmcnVoiceChannel(this, null);
            iHeliVoiceChannel.setError({
                code: '400',
                data: error
            });
            // @ts-ignore
            return iHeliVoiceChannel;
        }
    }
    // @ts-ignore
    async getVoiceChannelList(poschannelid, params) {
        try {
            const resVoChList = await worldViewerWindow.heliport.v3.api.channelSessionApi.fetchPositionChannelVoiceChannelList(poschannelid);
            if (resVoChList.status !== 'ok') {
                const iHeliVoiceChList = new IHeliCarnelianSmcnVoiceChannelList();
                var _resVoChList_errorCode;
                iHeliVoiceChList.setError({
                    code: (_resVoChList_errorCode = resVoChList.errorCode) !== null && _resVoChList_errorCode !== void 0 ? _resVoChList_errorCode : resVoChList.code,
                    data: resVoChList.data
                });
                return iHeliVoiceChList;
            }
            const voChList = resVoChList.data.voice_channels.map((voiceChannel)=>{
                return new CHeliCarnelianSmcnVoiceChannel(this, voiceChannel);
            });
            const offset = params.offset ? params.offset : 0;
            const limit = params.limit ? params.limit : null;
            return new IHeliCarnelianSmcnVoiceChannelList(voChList, offset, limit);
        } catch (error) {
            const iHeliVoiceChList = new IHeliCarnelianSmcnVoiceChannelList();
            iHeliVoiceChList.setError({
                code: '400',
                data: error
            });
            return iHeliVoiceChList;
        }
    }
    getCurrentVoiceChannel() {
        // @ts-ignore
        return this.m_current_voice_channel;
    }
    setCurrentVoiceChannel(voiceChannel) {
        this.m_current_voice_channel = voiceChannel;
    }
    async getLiveChannel(channelid) {
        try {
            const resLiveChDetail = await worldViewerWindow.heliport.v3.api.channelSessionApi.fetchLiveChannelDetail(channelid);
            if (resLiveChDetail.status !== 'ok') {
                const iHeliVoitionChannel = new CHeliCarnelianSmcnVoiceChannel(this, null);
                var _resLiveChDetail_errorCode;
                iHeliVoitionChannel.setError({
                    code: (_resLiveChDetail_errorCode = resLiveChDetail.errorCode) !== null && _resLiveChDetail_errorCode !== void 0 ? _resLiveChDetail_errorCode : resLiveChDetail.code,
                    data: resLiveChDetail.data
                });
                // @ts-ignore
                return iHeliVoitionChannel;
            }
            const liveChannelDetail = resLiveChDetail.data.live_channel;
            // @ts-ignore
            return new CHeliCarnelianSmcnLiveChannel(this, liveChannelDetail);
        } catch (error) {
            const iHeliLiveChannel = new CHeliCarnelianSmcnLiveChannel(this, null);
            iHeliLiveChannel.setError({
                code: '400',
                data: error
            });
            // @ts-ignore
            return iHeliLiveChannel;
        }
    }
    /**
   * @remarks
   * 座標チャンネル単位でのライブチャンネル一覧取得
   */ async getPositionChannelLiveChannelList(posionChannelCode) {
        const result = await worldViewerWindow.heliport.v3.api.channelSessionApi.fetchPositionChannelLiveChannelList(posionChannelCode);
        if (result.status !== 'ok') {
            const iHeliLiveChList = new IHeliCarnelianSmcnLiveChannelList();
            var _result_errorCode;
            iHeliLiveChList.setError({
                code: (_result_errorCode = result.errorCode) !== null && _result_errorCode !== void 0 ? _result_errorCode : result.code,
                data: result.data
            });
            // @ts-ignore
            return iHeliLiveChList;
        }
        const liveChList = result.data.live_channels.map((liveChannel)=>{
            return new CHeliCarnelianSmcnLiveChannel(this, liveChannel);
        });
        // @ts-ignore
        return new IHeliCarnelianSmcnLiveChannelList(liveChList);
    }
    /**
   * @remarks
   * ワールド単位でのライブチャンネル一覧取得
   */ async getWorldLiveChannelList(spatiumCode, worldCode) {
        const result = await worldViewerWindow.heliport.v3.api.channelSessionApi.fetchWorldLiveChannelList(spatiumCode, worldCode);
        if (result.status !== 'ok') {
            const iHeliLiveChList = new IHeliCarnelianSmcnLiveChannelList();
            var _result_errorCode;
            iHeliLiveChList.setError({
                code: (_result_errorCode = result.errorCode) !== null && _result_errorCode !== void 0 ? _result_errorCode : result.code,
                data: result.data
            });
            // @ts-ignore
            return iHeliLiveChList;
        }
        const liveChList = result.data.live_channels.map((liveChannel)=>{
            return new CHeliCarnelianSmcnLiveChannel(this, liveChannel);
        });
        // @ts-ignore
        return new IHeliCarnelianSmcnLiveChannelList(liveChList);
    }
    getCurrentLiveChannel() {
        return this.m_current_live_channel;
    }
    setCurrentLiveChannel(liveChannel) {
        this.m_current_live_channel = liveChannel;
    }
    async connectRoomAfterPeerOpen(roomid) {}
    // ハートビート
    // heliportが担うので
    sendHeartBeat() {}
    // プレイヤー
    createPlayer(playerId, userCode, channelSessionCode, role, createPlayer) {
        console.log('createPlayer', playerId);
        const player = new CHELCarnelianSmcnPlayer(playerId, userCode, getMixerRealSettingAt(HEL_AUDIO_TYPE_VOICE), role, createPlayer);
        player.setChannelSessionCode(channelSessionCode);
        this.playerListAdd(playerId, player);
    }
    releasePlayer(playerId) {
        const player = this.getPlayer(playerId);
        if (!player) {
            return false;
        }
        // @ts-ignore
        player.release();
        this.playerListRemove(playerId);
        return true;
    }
    // CRP Smcnでは使わない
    setPlayerStream(stream) {
        if (!stream.peerId) {
            debugLog('stream.peerId not');
            return;
        }
        const player = this.getPlayer(stream.peerId);
        if (player === null) {
            debugLog('CreatePlayer error : ' + stream.peerId);
            return;
        }
        player.setStream(stream);
    }
    getPlayer(playerId) {
        // @ts-ignore
        return this.m_PlayerMap.get(playerId);
    }
    getPlayerBy(keyName, findValue) {
        for (const [key, value] of this.m_PlayerMap.entries()){
            if (value.getValue(keyName) === findValue) {
                return value;
            }
        }
        return undefined;
    }
    playerListAdd(playerId, player) {
        // @ts-ignore
        this.m_PlayerMap.set(playerId, player);
    }
    playerListRemove(playerId) {
        this.m_PlayerMap.delete(playerId);
    }
    getPlayerList() {
        return this.m_PlayerMap;
    }
    releaseAllPlayer() {
        const playerList = this.getPlayerList();
        console.log('releaseAllPlayer playerList', playerList, playerList.size);
        playerList.forEach((player)=>{
            console.log('releaseAllPlayer player', player.getPlayerId(), player);
            if (player) {
                // TODO: このへん整理したい
                worldViewerWindow.hel_skyway_receive_data('leave', player.getPlayerId(), '');
                player.release();
                this.playerListRemove(player.getPlayerId());
                return;
            }
        });
    }
    // 他プレーヤのアバター表示切替コールバック
    setPlayerFullAvatarState(playerId, isFullAvatar) {
        const player = this.getPlayer(playerId);
        const prevHighFreqSync = player.isHighFrequentSync();
        player.setFullAvatarState(isFullAvatar);
        this.checkDispatchHighFrequentChange(prevHighFreqSync, player);
    }
    // 他プレーヤの他プレーヤのモーショントラッキング使用状況切替コールバック
    setPlayerMotionTrackingState(playerId, isMotionTracking) {
        const player = this.getPlayer(playerId);
        const prevHighFreqSync = player.isHighFrequentSync();
        player.setMotionTrackingState(isMotionTracking);
        this.checkDispatchHighFrequentChange(prevHighFreqSync, player);
    }
    // TODO
    // コールバック実行毎に下記関数を呼び出すのではなく、HeliPlayer側にEvent発火機能を実装したい
    checkDispatchHighFrequentChange(prevState, player) {
        if (!prevState && player.isHighFrequentSync()) {
            this.sendHighFrequentSyncSubscribe(player.getPlayerId(), true);
        }
        if (prevState && !player.isHighFrequentSync()) {
            this.sendHighFrequentSyncSubscribe(player.getPlayerId(), false);
        }
    }
    sendHighFrequentSyncSubscribe(playerId, subscribe) {
        if (subscribe) {
            this.sendData(`subscribe:${playerId}`);
        } else {
            this.sendData(`unsbscribe:${playerId}`);
        }
    }
    findObjectIdByRtcUserCode(rtcUserCode) {
        const crpFront = getCrpFront();
        for (const [objectId, crpObject] of crpFront.objects.entries()){
            if (`${crpObject.user.rtcUserCode}` === `${rtcUserCode}`) {
                return objectId;
            }
        }
        return null;
    }
    sendMyPlayerInfoToAllPlayer() {
        if (!this.isConnected() || !this.isConnectedPositionChannel()) return;
        this.sendData('join:' + getSkywayName() + ':' + getSkywayAvatarNumberForSend() + ':' + (getSkywayStartToggle() ? 1 : 0) + ':' + (getSkywayUseCustomAvatarIcon() ? 1 : 0));
        // アバター情報を送信する
        if (getSkywayAvatarNumberForSend() !== -1) {
            worldViewerWindow.hel_skyway_send_data('avatar:' + getSkywayAvatarNumberForSend());
        }
        // カスタムアバターアイコンのURLを送信する
        if (getSkywayUseCustomAvatarIcon() && getSkywayCustomAvatarIconURL() !== '') {
            worldViewerWindow.hel_skyway_send_data('customavataricon:' + getSkywayCustomAvatarIconURL());
        }
        // カスタムユーザーデータを送信する
        worldViewerWindow.hel_skyway_myinfo_bridge_call();
    }
    // プレイヤー：音量
    setPlayerVoiceMute(playreId, mute) {
        const Player = this.getPlayer(playreId);
        if (Player === null) return;
        // eslint-disable-next-line new-cap
        Player.SetMute(mute);
        if (this.m_SMCNWRemoteTrackPublication != null) {
            try {
                this.m_SMCNWRemoteTrackPublication.setMute(mute);
            } catch (err) {
                // trackがない場合でも、処理を継続する
                console.warn(err);
            }
        }
    }
    setPlayerVoiceAttenuate(playerId, volume) {
        // console.log('setPlayerVoiceAttenuate', playerId, volume)
        if (typeof volume !== 'number') {
            return;
        }
        const player = this.getPlayer(playerId);
        if (!player) {
            return;
        }
        player.SetVoiceAttenuate(volume);
    }
    setAllPlayerVoiceVolume(volume) {
        const playerList = this.getPlayerList();
        playerList.forEach((player)=>{
            if (player) {
                player.setVolume(volume);
            }
        });
        if (this.m_SMCNWRemoteTrackPublication != null) {
            try {
                this.m_SMCNWRemoteTrackPublication.setVolume(volume);
            } catch (err) {
                // trackがない場合でも、処理を継続する
                console.warn(err);
            }
        }
    }
    handleMessageScreenShare(playerId, data, role) {
        if (data === 'screenshare:tell') {
            const fn = getSkywayOnTellScreenShareStart();
            if (fn !== undefined) {
                fn();
                return;
            }
        }
        if (data === 'screenshare:waitstart') {
            const fn = getSkywayOnTellWaitScreenShare();
            if (fn !== undefined) {
                fn();
                return;
            }
        }
        const paramsScreenShare = data.split(':');
        if (paramsScreenShare[1] === 'start') {
            const player = this.getPlayer(playerId);
            if (player === null) {
                return;
            }
            const remoteVideoStream = player.getVideoMediaStream();
            if (worldViewerWindow.hel_video_is_playing_same_stream(remoteVideoStream)) {
                return;
            }
            // グローバルにhel_onReceiveNoticeScreenShareStartが定義されていた場合に実行する
            if (typeof worldViewerWindow.hel_onReceiveNoticeScreenShareStart === 'function') {
                worldViewerWindow.hel_onReceiveNoticeScreenShareStart(playerId, remoteVideoStream, paramsScreenShare[2], paramsScreenShare[3]);
            }
            // 予約
            this.reserveRemotoVideoStream(remoteVideoStream, paramsScreenShare[2], paramsScreenShare[3]);
            // HeliScriptのコールバックを呼び出す
            worldViewerWindow.hel_setText(worldViewerWindow.ETextParamType_OnReceivedStartScreenShare, '');
        }
        if (paramsScreenShare[1] === 'stop') {
            // グローバルにhel_onReceiveNoticeScreenShareStopが定義されていた場合に実行する
            if (typeof worldViewerWindow.hel_onReceiveNoticeScreenShareStop === 'function') {
                worldViewerWindow.hel_onReceiveNoticeScreenShareStop(playerId);
            } else {
                worldViewerWindow.hel_video_stop();
                // HeliScriptのコールバックを呼び出す
                worldViewerWindow.hel_setText(worldViewerWindow.ETextParamType_OnReceivedStopScreenShare, '');
            }
        }
    }
    // 低レベルデータ送信
    sendData(param) {
        // console.log('SEND DATA: ', param)
        if (!worldViewerWindow.crpFront) {
            return;
        }
        const crpFront = getCrpFront();
        crpFront.sendData(param);
    }
    // 画面共有が可能なconnect
    async connectWithDisplayMedia(configKey) {
        await this.connect(configKey);
    }
    async startScreenShare(videoItemName, videoMaterialName, useCamera, useAudio) {
        if (!navigator.mediaDevices) {
            debugLog('navigator.mediaDevices not found');
            return;
        }
        const localVideoStream = await this.getLocalVideoStream(useCamera, useAudio);
        // ローカル画面共有の再生
        worldViewerWindow.hel_video_stop();
        helcore_video_play(videoItemName, videoMaterialName, './Video/blankVideo.mp4', true, false, false, undefined);
        this.setScreenShareCurrentInfo(videoItemName, videoMaterialName);
        const video = getVideo();
        setTimeout(()=>{
            if (video != null) {
                if (localVideoStream) {
                    video.srcObject = localVideoStream;
                }
                video.play();
                this.sendScreenShareStart();
            }
        }, 500);
    }
    setScreenShareCurrentInfo(videoItemName, videoMaterialName) {
        this.m_ScreenShare_CurrentVideoItemName = videoItemName;
        this.m_ScreenShare_CurrentVideoMaterialName = videoMaterialName;
    }
    sendScreenShareStart() {
        if (this.m_ScreenShare_CurrentVideoItemName === '') return;
        if (this.m_ScreenShare_CurrentVideoMaterialName === '') return;
        worldViewerWindow.hel_skyway_send_data(`screenshare:start:${this.m_ScreenShare_CurrentVideoItemName}:${this.m_ScreenShare_CurrentVideoMaterialName}`);
    }
    async getLocalVideoStream(useCamera, useAudio) {
        if (useCamera) {
            const localVideoStream = await navigator.mediaDevices.getUserMedia({
                audio: useAudio,
                video: true
            }).catch(console.error);
            if (!localVideoStream) {
                console.error('');
                return;
            }
            return localVideoStream;
        } else {
            const displayMediaOptions = {
                video: {
                    cursor: 'always'
                },
                audio: false
            };
            // @ts-ignore
            const localVideoStream = await navigator.mediaDevices.getDisplayMedia(displayMediaOptions);
            localVideoStream.getTracks()[0].addEventListener('ended', ()=>{
                console.log('screen share ended');
            // onScreenShareCancel();
            });
            return localVideoStream;
        }
    }
    async stopScreenShare() {
    // こんな命令はないので、一旦コメントアウトawait worldViewerWindow.smcnClient.unpublishVideoStream();
    }
    reserveRemotoVideoStream(remoteVideoStream, videoItemName, videoMaterialName) {
        this.m_skyway_reseved_remoteVideoStream = remoteVideoStream;
        this.m_skyway_reseved_videoItemName = videoItemName;
        this.m_skyway_reseved_videoMaterialName = videoMaterialName;
    }
    playScreenShare() {
        worldViewerWindow.hel_skyway_send_data('screenshare:waitstart');
    }
    playScreenShareReserved() {
        worldViewerWindow.hel_skyway_play_remote_video_stream(this.m_skyway_reseved_remoteVideoStream, this.m_skyway_reseved_videoItemName, this.m_skyway_reseved_videoMaterialName);
    }
    // コールバック
    setCallback(callback) {
        this.m_IHeliNetworkCallback = callback;
    }
    getCallback() {
        return this.m_IHeliNetworkCallback;
    }
    parseJwt(token) {
        if (typeof token !== 'string') {
            return null;
        }
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    }
    async getDecodedChannelSession() {
        const channelSessionJwt = (await worldViewerWindow.heliport.v3.api.channelSessionApi.getChannelSessionJwt()).data;
        return this.parseJwt(channelSessionJwt);
    }
    async getMicDevices() {
        return await getAudioInputDevices();
    }
    async changeMicDevice(deviceId) {
        if (worldViewerWindow.smcnClient) {
            await worldViewerWindow.smcnClient.switchActiveDevice('audioinput', deviceId);
        }
        /* スピーカーモードと通常モードで運用するため不要
    if (worldViewerWindow.agoraLiveClient) {
      await worldViewerWindow.agoraLiveClient.changeInputDevices({
        microphoneId: deviceId
      });
    }
    */ return true;
    }
    getApiNotificationHandler() {
        return this.m_ApiNotification;
    }
    apiNotificationReciever(scope, type, params) {
        if (this.m_ApiNotification == null) {
            return;
        }
        if (type === worldViewerWindow.NOTIFICATION_ACTION_TYPE_TOAST) {
            worldViewerWindow.hel_toast_notify_message(params.Message, 250, 8000, 250);
        } else if (type === worldViewerWindow.NOTIFICATION_ACTION_TYPE_SYSTEM) {
            var _params_CreatedAt;
            // TODO: サーバー側で修正頂くまでの暫定対応
            if ((_params_CreatedAt = params.CreatedAt) === null || _params_CreatedAt === void 0 ? void 0 : _params_CreatedAt.seconds) {
                var _params_CreatedAt1;
                params.CreatedAt = '0000-00-00T' + new Date(((_params_CreatedAt1 = params.CreatedAt) === null || _params_CreatedAt1 === void 0 ? void 0 : _params_CreatedAt1.seconds) * 1000).toLocaleTimeString('Ja-JP', {
                    hour: '2-digit',
                    minute: '2-digit',
                    timeZone: 'UTC'
                });
            }
            const jsonString = JSON.stringify(params).replace(/'/g, '\\"');
            worldViewerWindow.hel_textchat_notify_message(jsonString, true);
        }
        this.m_ApiNotification.dispatchEvent(scope, type, params);
    }
    async apiChangeItemPropertySender(refId, key, value) {
        var _this_m_current_position_channel_positionChannel, _this_m_current_position_channel_positionChannel1, _this_m_current_position_channel_positionChannel2;
        if (this.m_current_position_channel == null) {
            return null;
        }
        // APIにメッセージを送信
        return await worldViewerWindow.heliport.v3.api.ingameStateManagerApi.changeItemProperty((_this_m_current_position_channel_positionChannel = this.m_current_position_channel.positionChannel) === null || _this_m_current_position_channel_positionChannel === void 0 ? void 0 : _this_m_current_position_channel_positionChannel.spatium_code, (_this_m_current_position_channel_positionChannel1 = this.m_current_position_channel.positionChannel) === null || _this_m_current_position_channel_positionChannel1 === void 0 ? void 0 : _this_m_current_position_channel_positionChannel1.world_code, (_this_m_current_position_channel_positionChannel2 = this.m_current_position_channel.positionChannel) === null || _this_m_current_position_channel_positionChannel2 === void 0 ? void 0 : _this_m_current_position_channel_positionChannel2.channel_id, refId, {
            [key]: value
        });
    }
    async apiChangeItemPropertySenderMulti(refId, data) {
        var _this_m_current_position_channel_positionChannel, _this_m_current_position_channel_positionChannel1, _this_m_current_position_channel_positionChannel2;
        if (this.m_current_position_channel == null) {
            return null;
        }
        // APIにメッセージを送信
        return await worldViewerWindow.heliport.v3.api.ingameStateManagerApi.changeItemProperty((_this_m_current_position_channel_positionChannel = this.m_current_position_channel.positionChannel) === null || _this_m_current_position_channel_positionChannel === void 0 ? void 0 : _this_m_current_position_channel_positionChannel.spatium_code, (_this_m_current_position_channel_positionChannel1 = this.m_current_position_channel.positionChannel) === null || _this_m_current_position_channel_positionChannel1 === void 0 ? void 0 : _this_m_current_position_channel_positionChannel1.world_code, (_this_m_current_position_channel_positionChannel2 = this.m_current_position_channel.positionChannel) === null || _this_m_current_position_channel_positionChannel2 === void 0 ? void 0 : _this_m_current_position_channel_positionChannel2.channel_id, refId, data);
    }
    async apiCommandItemPropertySender(commands) {
        var _this_m_current_position_channel_positionChannel, _this_m_current_position_channel_positionChannel1, _this_m_current_position_channel_positionChannel2;
        if (this.m_current_position_channel == null) {
            return null;
        }
        // APIにメッセージを送信
        return await worldViewerWindow.heliport.v3.api.ingameStateManagerApi.commandItemProperty((_this_m_current_position_channel_positionChannel = this.m_current_position_channel.positionChannel) === null || _this_m_current_position_channel_positionChannel === void 0 ? void 0 : _this_m_current_position_channel_positionChannel.spatium_code, (_this_m_current_position_channel_positionChannel1 = this.m_current_position_channel.positionChannel) === null || _this_m_current_position_channel_positionChannel1 === void 0 ? void 0 : _this_m_current_position_channel_positionChannel1.world_code, (_this_m_current_position_channel_positionChannel2 = this.m_current_position_channel.positionChannel) === null || _this_m_current_position_channel_positionChannel2 === void 0 ? void 0 : _this_m_current_position_channel_positionChannel2.channel_id, commands);
    }
    async apiCommandWorldItemPropertySender(commands) {
        var _this_m_current_position_channel_positionChannel, _this_m_current_position_channel_positionChannel1;
        if (this.m_current_position_channel == null) {
            return null;
        }
        // APIにメッセージを送信
        return await worldViewerWindow.heliport.v3.api.ingameStateManagerApi.commandWorldItemProperty({
            spatiumCode: (_this_m_current_position_channel_positionChannel = this.m_current_position_channel.positionChannel) === null || _this_m_current_position_channel_positionChannel === void 0 ? void 0 : _this_m_current_position_channel_positionChannel.spatium_code,
            worldCode: (_this_m_current_position_channel_positionChannel1 = this.m_current_position_channel.positionChannel) === null || _this_m_current_position_channel_positionChannel1 === void 0 ? void 0 : _this_m_current_position_channel_positionChannel1.world_code,
            command: commands
        });
    }
    async requestRoomItemSyncOwnership(objectIds) {
        var _this_m_current_position_channel_positionChannel, _this_m_current_position_channel_positionChannel1, _this_m_current_position_channel_positionChannel2;
        if (this.m_current_position_channel == null) {
            return null;
        }
        const spatiumCode = (_this_m_current_position_channel_positionChannel = this.m_current_position_channel.positionChannel) === null || _this_m_current_position_channel_positionChannel === void 0 ? void 0 : _this_m_current_position_channel_positionChannel.spatium_code;
        const worldCode = (_this_m_current_position_channel_positionChannel1 = this.m_current_position_channel.positionChannel) === null || _this_m_current_position_channel_positionChannel1 === void 0 ? void 0 : _this_m_current_position_channel_positionChannel1.world_code;
        const channelId = (_this_m_current_position_channel_positionChannel2 = this.m_current_position_channel.positionChannel) === null || _this_m_current_position_channel_positionChannel2 === void 0 ? void 0 : _this_m_current_position_channel_positionChannel2.channel_id;
        const res = await worldViewerWindow.heliport.v3.api.ingameStateManagerApi.requestObjectOwnership({
            spatiumCode,
            worldCode,
            channelId,
            objectIds
        });
        if (res.status === 'ok') {
            res.data.forEach((result)=>{
                if (!result.error) {
                    this.assignOwnedObjectId(result.objectId);
                }
            });
        }
        return res;
    }
    async releaseRoomItemSyncOwnership(objectIds) {
        var _this_m_current_position_channel_positionChannel, _this_m_current_position_channel_positionChannel1, _this_m_current_position_channel_positionChannel2;
        if (this.m_current_position_channel == null) {
            return null;
        }
        const spatiumCode = (_this_m_current_position_channel_positionChannel = this.m_current_position_channel.positionChannel) === null || _this_m_current_position_channel_positionChannel === void 0 ? void 0 : _this_m_current_position_channel_positionChannel.spatium_code;
        const worldCode = (_this_m_current_position_channel_positionChannel1 = this.m_current_position_channel.positionChannel) === null || _this_m_current_position_channel_positionChannel1 === void 0 ? void 0 : _this_m_current_position_channel_positionChannel1.world_code;
        const channelId = (_this_m_current_position_channel_positionChannel2 = this.m_current_position_channel.positionChannel) === null || _this_m_current_position_channel_positionChannel2 === void 0 ? void 0 : _this_m_current_position_channel_positionChannel2.channel_id;
        objectIds.forEach((objectId)=>{
            this.unassignOwnedObjectId(objectId);
        });
        return await worldViewerWindow.heliport.v3.api.ingameStateManagerApi.releaseObjectOwnership({
            spatiumCode,
            worldCode,
            channelId,
            objectIds
        });
    }
    async refreshItemSyncOwnershipHeartbeat() {
        var _this_m_current_position_channel_positionChannel, _this_m_current_position_channel_positionChannel1, _this_m_current_position_channel_positionChannel2;
        if (this.m_current_position_channel == null) {
            return null;
        }
        const spatiumCode = (_this_m_current_position_channel_positionChannel = this.m_current_position_channel.positionChannel) === null || _this_m_current_position_channel_positionChannel === void 0 ? void 0 : _this_m_current_position_channel_positionChannel.spatium_code;
        const worldCode = (_this_m_current_position_channel_positionChannel1 = this.m_current_position_channel.positionChannel) === null || _this_m_current_position_channel_positionChannel1 === void 0 ? void 0 : _this_m_current_position_channel_positionChannel1.world_code;
        const channelId = (_this_m_current_position_channel_positionChannel2 = this.m_current_position_channel.positionChannel) === null || _this_m_current_position_channel_positionChannel2 === void 0 ? void 0 : _this_m_current_position_channel_positionChannel2.channel_id;
        const objectIds = [
            ...this.m_ownedObjectIdSetList
        ];
        const result = await worldViewerWindow.heliport.v3.api.ingameStateManagerApi.refreshObjectOwnership({
            spatiumCode,
            worldCode,
            channelId,
            objectIds
        });
        return result;
    }
    assignOwnedObjectId(objectId) {
        this.m_ownedObjectIdSetList.add(objectId);
    }
    unassignOwnedObjectId(objectId) {
        this.m_ownedObjectIdSetList.delete(objectId);
    }
    startOwnershipHeartbeatInterval() {
        this.m_ownershipHeartbeatInterval = setInterval(()=>{
            if (this.m_ownedObjectIdSetList.size > 0) {
                this.refreshItemSyncOwnershipHeartbeat();
            }
        }, 5000);
    }
    stopOwnershipHeartbeatInterval() {
        clearInterval(this.m_ownershipHeartbeatInterval);
        this.m_ownedObjectIdSetList = new Set();
    }
    initApiNotificationHandler() {
        var _this_m_ApiNotification;
        (_this_m_ApiNotification = this.m_ApiNotification) === null || _this_m_ApiNotification === void 0 ? void 0 : _this_m_ApiNotification.init();
    }
    /**
   * TODO
   * エンジン対応するまでの暫定実装
   */ getSelfPlayerRole() {
        var _this_m_selfPlayerInfo, _this_m_selfPlayerInfo1;
        // user_roleがnullの場合がある
        if (((_this_m_selfPlayerInfo = this.m_selfPlayerInfo) === null || _this_m_selfPlayerInfo === void 0 ? void 0 : _this_m_selfPlayerInfo.user_role) == null) {
            return 'normal';
        }
        return (_this_m_selfPlayerInfo1 = this.m_selfPlayerInfo) === null || _this_m_selfPlayerInfo1 === void 0 ? void 0 : _this_m_selfPlayerInfo1.user_role;
    }
    getChannelSessionCodeByPlayerId(playerId) {
        var _this_m_selfPlayerInfo;
        const channelSessionCode = (_this_m_selfPlayerInfo = this.m_selfPlayerInfo) === null || _this_m_selfPlayerInfo === void 0 ? void 0 : _this_m_selfPlayerInfo.channel_session_code;
        if (!playerId) {
            return channelSessionCode;
        }
        if (playerId === this.getPeerId()) {
            return channelSessionCode;
        }
        for (const [objectId, player] of this.getPlayerList().entries()){
            if (player.getPlayerId() === playerId) {
                return player.getChannelSessionCode();
            }
        }
        return '';
    }
    getPlayerIdByChannelSessionCode(channelSessionCode) {
        var _this_m_selfPlayerInfo;
        const playerId = this.getPeerId();
        if (!channelSessionCode) {
            return playerId;
        }
        if (channelSessionCode === ((_this_m_selfPlayerInfo = this.m_selfPlayerInfo) === null || _this_m_selfPlayerInfo === void 0 ? void 0 : _this_m_selfPlayerInfo.channel_session_code)) {
            return playerId;
        }
        for (const [objectId, player] of this.getPlayerList().entries()){
            if (player.getChannelSessionCode() === channelSessionCode) {
                return player.getPlayerId();
            }
        }
        return '';
    }
    initLiveClient() {
        console.log('initLiveClient start');
        const agoraLiveClient = this.getLiveClient();
        console.log('initLiveClient agoraLiveClient', agoraLiveClient);
        agoraLiveClient.onConnected((localUser)=>{
            var _this_m_IHeliNetworkCallback;
            (_this_m_IHeliNetworkCallback = this.m_IHeliNetworkCallback) === null || _this_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_IHeliNetworkCallback.OnNetLiveConnected();
        });
        agoraLiveClient.onDisconnected(()=>{
            var _this_m_IHeliNetworkCallback;
            (_this_m_IHeliNetworkCallback = this.m_IHeliNetworkCallback) === null || _this_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_IHeliNetworkCallback.OnNetLiveDisconnected();
        });
        agoraLiveClient.importEngineMasterVolume(worldViewerWindow.g_hel_RealMixer, worldViewerWindow.g_hel_MixerMute, worldViewerWindow.HEL_AUDIO_TYPE_VOICE, worldViewerWindow.HEL_AUDIO_TYPE_VIDEO);
        agoraLiveClient.startObserveVolumeSetting();
        agoraLiveClient.on('subscribePlayerAudio', ({ user  })=>{
            console.log('subscribePlayerAudio user:', user.hasAudio);
            if (user.audioTrack) {
                user.audioTrack.play();
            }
        });
        agoraLiveClient.on('stopRemoteVideoLiveStream', ({ user , remoteVideoLiveStream  })=>{
            var _this_m_IHeliNetworkCallback;
            if (this.isPlayingLiveVideo()) {
                console.log('live streaming stopped', user, remoteVideoLiveStream);
                this.clearLiveVideoSrc();
                this.stopLiveVideo();
            }
            (_this_m_IHeliNetworkCallback = this.m_IHeliNetworkCallback) === null || _this_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_IHeliNetworkCallback.OnNetLiveVideoEnded();
        });
        agoraLiveClient.on('startRemoteVideoLiveStream', ({ user , remoteVideoLiveStream  })=>{
            console.log('live streaming start startRemoteVideoLiveStream', user, remoteVideoLiveStream);
            this.prepareLiveVideoSrc(remoteVideoLiveStream);
        });
        agoraLiveClient.on('updateRemoteVideoLiveStream', ({ user , remoteVideoLiveStream  })=>{
            const isPlayingLiveVideo = this.isPlayingLiveVideo();
            console.log('live streaming update updateRemoteVideoLiveStream', user, remoteVideoLiveStream, isPlayingLiveVideo);
            if (isPlayingLiveVideo) {
                this._setLiveVideoSrc(remoteVideoLiveStream);
                this.playLiveVideo();
            } else {
                this.prepareLiveVideoSrc(remoteVideoLiveStream);
            }
        });
        window.addEventListener('beforeunload', ()=>{
            agoraLiveClient.close();
        });
        // 他プレーヤーjoin自
        agoraLiveClient.onUserJoined((agoraUser)=>{
            var // @ts-ignore
            // player.setAgoraUser(agoraUser);
            // ライブチャンネルへのJoinを通知
            _this_m_IHeliNetworkCallback;
            console.log('agoraLiveClient onUserJoined', agoraUser);
            const objectId = this.findObjectIdByRtcUserCode(agoraUser.uid);
            const player = this.getPlayer(objectId || '');
            // const player = this.getPlayerBy('rtcUserCode', agoraUser.uid);
            if (!player) {
                console.warn('no player agoraUser.uid', agoraUser.uid);
                return;
            }
            (_this_m_IHeliNetworkCallback = this.m_IHeliNetworkCallback) === null || _this_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_IHeliNetworkCallback.OnNetLiveRemoteJoin(player.getPlayerId());
        });
        agoraLiveClient.onUserLeft((agoraUser)=>{
            var // ライブチャンネルからのLeaveを通知
            _this_m_IHeliNetworkCallback;
            console.log('agoraLiveClient onUserLeft', agoraUser);
            // const objectId = this.findObjectIdByRtcUserCode(agoraUser.uid)
            // const player = this.getPlayer(objectId || '');
            const player = this.getPlayerBy('rtcUserCode', agoraUser.uid);
            if (!player) {
                console.warn('no player agoraUser.uid', agoraUser.uid);
                return;
            }
            (_this_m_IHeliNetworkCallback = this.m_IHeliNetworkCallback) === null || _this_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_IHeliNetworkCallback.OnNetLiveRemoteLeave(player.getPlayerId());
        });
        worldViewerWindow.agoraLiveClient = agoraLiveClient;
        console.log('initLiveClient done');
    }
    getLiveClient() {
        if (!worldViewerWindow.agoraLiveClient) {
            worldViewerWindow.agoraLiveClient = new AgoraClient({
                mode: 'live',
                ctrlRemoteVideoLiveStreamVolume: true,
                ctrlPlayerVoiceVolume: true
            });
        }
        return worldViewerWindow.agoraLiveClient;
    }
    prepareLiveVideoSrc(mediaStream) {
        var // HeliScript側にストリーム受信通知
        _this_m_IHeliNetworkCallback;
        this._setLiveVideoSrc(mediaStream);
        (_this_m_IHeliNetworkCallback = this.m_IHeliNetworkCallback) === null || _this_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_IHeliNetworkCallback.OnNetLiveVideoStarted();
        this.checkAndPlayVideoStream();
    }
    // ライブチャンネル動画 動画再生パネルの設定
    prepareLiveVideoItem(itemName, materialName) {
        this.m_LiveVideoItem = {
            itemName,
            materialName
        };
        return this.checkAndPlayVideoStream();
    }
    clearLiveVideoSrc() {
        this._setLiveVideoSrc(null);
    }
    _setLiveVideoSrc(mediaStream) {
        this.m_LiveVideoSrc = mediaStream;
    }
    standbyPlayLiveVideo() {
        this.m_stanbyPlayVideoStreamFlg = true;
        return this.checkAndPlayVideoStream();
    }
    // ライブ動画の再生 ※ prepare済
    // @ts-ignore
    playLiveVideo() {
        if (!this.isLiveVideoPlayReady()) {
            return false;
        }
        if (this.m_LiveVideoItem === null) {
            return false;
        }
        worldViewerWindow.hel_video_stop();
        helcore_video_play(this.m_LiveVideoItem.itemName, this.m_LiveVideoItem.materialName, './Video/blankVideo.mp4', true, false, false, undefined);
        setTimeout(()=>{
            if (worldViewerWindow.g_Video !== null) {
                const onceOption = {
                    once: true
                };
                // ライブ動画ストリームの停止イベント発火と重複イベントの除去
                const videoStopCallbackPause = ()=>{
                    var _this_m_IHeliNetworkCallback;
                    console.log('g_Video ended');
                    worldViewerWindow.agoraLiveClient.stopLiveStreamAudio();
                    (_this_m_IHeliNetworkCallback = this.m_IHeliNetworkCallback) === null || _this_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_IHeliNetworkCallback.OnNetLiveVideoStop();
                    worldViewerWindow.g_Video.removeEventListener('play', videoStopCallbackPlay, onceOption);
                };
                const videoStopCallbackPlay = ()=>{
                    var _this_m_IHeliNetworkCallback;
                    console.log('g_Video play 2nd');
                    (_this_m_IHeliNetworkCallback = this.m_IHeliNetworkCallback) === null || _this_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_IHeliNetworkCallback.OnNetLiveVideoStop();
                    worldViewerWindow.g_Video.removeEventListener('pause', videoStopCallbackPause, onceOption);
                };
                worldViewerWindow.g_Video.addEventListener('play', ()=>{
                    var _this_m_IHeliNetworkCallback;
                    (_this_m_IHeliNetworkCallback = this.m_IHeliNetworkCallback) === null || _this_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_IHeliNetworkCallback.OnNetLiveVideoPlay();
                    worldViewerWindow.g_Video.addEventListener('play', videoStopCallbackPlay, onceOption);
                    worldViewerWindow.g_Video.addEventListener('pause', videoStopCallbackPause, onceOption);
                }, onceOption);
                worldViewerWindow.g_Video.srcObject = this.m_LiveVideoSrc;
                worldViewerWindow.agoraLiveClient.playLiveStreamAudio();
                worldViewerWindow.g_Video.play();
                worldViewerWindow.hel_video_open_genericwindow();
            }
        }, 500);
        return true;
    }
    // ライブ動画の停止
    stopLiveVideo() {
        worldViewerWindow.hel_video_stop();
        worldViewerWindow.hel_video_close_genericwindow();
    }
    // ライブ動画の再生中判定
    isPlayingLiveVideo() {
        const video = getVideo();
        if (video === undefined || video.paused === true) {
            return false;
        }
        if (video.srcObject && this.m_LiveVideoSrc && 'id' in video.srcObject && video.srcObject.id === this.m_LiveVideoSrc.id) {
            return true;
        }
        return false;
    }
    // ライブ動画再生に必要なデータが揃っているか
    isLiveVideoPlayReady() {
        if (this.m_LiveVideoItem === null || !this.m_LiveVideoItem.itemName || !this.m_LiveVideoItem.materialName) {
            return false;
        }
        if (this.m_LiveVideoSrc === null) {
            return false;
        }
        if (this.m_LiveVideoSrc && this.m_LiveVideoSrc.getVideoTracks && this.m_LiveVideoSrc.getVideoTracks().length > 0) {
            return true;
        }
        console.warn('no video tracks');
        return false;
    }
    setLiveVideoAutoPlay(autoPlay) {
        this.m_autoPlayLiveVideoStreamFlg = autoPlay;
    }
    checkAndPlayVideoStream() {
        if (this.m_LiveVideoSrc === null) {
            const result = 'FAIL_NO_STREAM';
            console.log('LiveVideo checkAndPlayVideoStream', result);
            return result;
        }
        if (this.m_LiveVideoItem === null) {
            const result = 'FAIL_NO_PLAY_ITEM';
            console.log('LiveVideo checkAndPlayVideoStream', result);
            return result;
        }
        if (this.isLiveVideoPlayReady() === false) {
            const result = 'FAIL_NO_VIDEO_TRACK';
            console.log('LiveVideo checkAndPlayVideoStream', result);
            return result;
        }
        if (this.m_stanbyPlayVideoStreamFlg === false) {
            const result = 'FAIL_NO_PLAY_STANDBY';
            console.log('LiveVideo checkAndPlayVideoStream', result);
            return result;
        }
        // このまま自動再生するか
        if (this.m_autoPlayLiveVideoStreamFlg) {
            const result = 'PLAY_START';
            this.playLiveVideo();
            return result;
        }
        const result = 'PLAYABLE';
        console.log('LiveVideo checkAndPlayVideoStream', result, this.isPlayingLiveVideo());
        // HeliScript側に再生準備完了通知（新UI）
        if (!this.isPlayingLiveVideo()) {
            var _this_m_IHeliNetworkCallback;
            (_this_m_IHeliNetworkCallback = this.m_IHeliNetworkCallback) === null || _this_m_IHeliNetworkCallback === void 0 ? void 0 : _this_m_IHeliNetworkCallback.OnNetLiveConfirmPlayVideo();
        }
        return result;
    }
    // positionChannelCode: string | null = null
    // コンストラクタ
    constructor(){
        // マイク許可状態
        _defineProperty(this, "m_MicPermissionState", EHeliMicPermissionState.Prompt);
        _defineProperty(this, "m_Mic_ready", false);
        _defineProperty(this, "m_localAgoraTrack", {
            audioTrack: null,
            videoTrack: null
        });
        // プレイヤーリスト
        // m_PlayerList: Array<CHELCarnelianSmcnPlayer | null> = [];
        _defineProperty(this, "m_PlayerMap", new Map());
        // 画面共有
        _defineProperty(this, "m_ScreenShare_CurrentVideoItemName", '');
        _defineProperty(this, "m_ScreenShare_CurrentVideoMaterialName", '');
        _defineProperty(this, "m_skyway_reseved_remoteVideoStream", null);
        _defineProperty(this, "m_skyway_reseved_videoItemName", '');
        _defineProperty(this, "m_skyway_reseved_videoMaterialName", '');
        // ライブチャンネル
        _defineProperty(this, "m_LiveVideoSrc", null);
        _defineProperty(this, "m_LiveVideoItem", null);
        _defineProperty(this, "m_autoPlayLiveVideoStreamFlg", false);
        _defineProperty(this, "m_stanbyPlayVideoStreamFlg", false);
        // チャンネル
        _defineProperty(this, "m_current_position_channel", null);
        _defineProperty(this, "m_current_voice_channel", null);
        _defineProperty(this, "m_current_live_channel", null);
        // コールバック
        _defineProperty(this, "m_IHeliNetworkCallback", null);
        _defineProperty(this, "m_ApiNotification", null);
        _defineProperty(this, "m_selfPlayerInfo", null);
        // 頻度軽減のため
        _defineProperty(this, "m_CurrentUserPosition", {
            x: 0,
            y: 0,
            z: 0
        });
        _defineProperty(this, "m_CurrentUserOrientation", {
            x: 0.0,
            y: 0.0,
            z: 0.0,
            w: 0.0
        });
        _defineProperty(this, "m_UserPosition", {
            x: 0,
            y: 0,
            z: 0
        });
        _defineProperty(this, "m_UserOrientation", {
            x: 0.0,
            y: 0.0,
            z: 0.0,
            w: 0.0
        });
        _defineProperty(this, "enabledInterval", null);
        _defineProperty(this, "m_SMCNWLocalTrackPublication", null);
        _defineProperty(this, "m_SMCNWRemoteTrackPublication", null);
        _defineProperty(this, "m_SMCNWMediaTrackSettings", {
            inputMute: true,
            outputMute: false,
            outputEnable: true
        });
        _defineProperty(this, "m_SMCNDefaultVoiceChannelName", 'Default');
        _defineProperty(this, "m_SMCNDefaultVoiceChannel", null);
        _defineProperty(this, "m_isGlobal", true);
        _defineProperty(this, "m_CChannelSessionApi", null);
        _defineProperty(this, "m_CCrpRegist", null);
        _defineProperty(this, "m_ownedObjectIdSetList", void 0);
        _defineProperty(this, "m_ownershipHeartbeatInterval", undefined);
        _defineProperty(this, "sanitizeAvatarId", (role, avatarId)=>{
            const isProtectedAvatar = true; // protectedAvatarIdList.includes(parseInt(avatarId))
            const invalidAvatarId = isProtectedAvatar && role !== 'presenter' && role !== 'staff';
            return invalidAvatarId ? '0' : avatarId;
        });
        this.m_ApiNotification = new CApiNotification();
        this.m_selfPlayerInfo = null;
        this.m_CChannelSessionApi = new CChannelSessionApi();
        this.m_CCrpRegist = new CCrpRegist();
        this.m_ownedObjectIdSetList = new Set();
        this.initEvent();
    }
}
